import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import './RestoProductStock.css';
import {
    Grid,
    TextField,
    Box,
    Checkbox,
    TableBody,
    Card,
    FormControl } from "../ui";
import EditIcon from "../ui/icons/Edit";
import InventoryIcon from '../ui/icons/Inventory';
import AddLinkIcon from '../ui/icons/AddLink';
import TableViewIcon from '../ui/icons/TableView';
import ViewCozyOutlinedIcon from '../ui/icons/ViewCozyOutlined';
import Autocomplete from "../ui/Autocomplete";
import {
  GET_CATEOGORY_DATA,
  GET_RESTAURANT_DATA,
  SET_RESTAURANT_DATA,
  getPreUrlAccordingToCart,
  SUCCESS,
  // ItemStatus,
  FoodType,
  Spicy,
  OfferType,
  getAuthSession,
  ITEMWISEOFFER,
  GETSINGLECONFIGS,
  isRoleAllowed,
  INITIAL_PAGEMODEL,
  THEMEMGMT,
  ECARTAPP,
  ItemStatus,
  printDebugLog,
  isFeatureAllowed,
  DELETEIMAGE,
  printInfoLog,
  GETFOODITEMSUGGESTION,
  isEmpty,
  STOCKMGMT,
  GET_SUPPLIER_FEW_DATA,
  SUPMGMT,
  STOCKPRICINGFEATURE,
  ITEM_CGST,
  ITEM_SGST,
  GET_CONVERSIONTYPE_DATA,
  GETRESTOSTOCKENTRY,
  isNumberEmpty,
  SETRESTOSTOCKENTRY,
  formatDateInReact,
  formatDateInSnp,
  SETLINKOSTOCKENTRY,
  GETLINKOSTOCKENTRY,
  ITEMMULTIACCOUNT,
  GETVIDEOPATH,
  RECPMGMT,
  FOODIMAGEVIAID,
  GETQUICKITEMS,
  local_test_url,
  ROLE_CREATE,
  ROLE_UPDATE,
  INVSTOCKMGMT,
  FOODITEMPRODUCTMGMT
} from "../../constants/constant";
import ImageUploadService from "../../service/imageUploadService";
import axios from "axios";
import DialogBox from "../global/DialogBox";
import {
  Button, RadioGroup, FormControlLabel,
  FormLabel, Radio
} from "../ui";
import spiceLevel3Logo from '../../assets/chili-pepper.png';
import spiceLevel1Logo from '../../assets/chili.png';
import Table from '../ui/Table';
import TableCell from '../ui/TableCell';
import TableContainer from '../ui/TableContainer';
import TableHead from '../ui/TableHead';
import TableRow from '../ui/TableRow';
import Paper from '../ui/Paper';
import CustomDataGrid from "../global/CustomDataGrid";
import { useSelector } from "react-redux";
import { snpAxios } from '../global/api';
import { calculateRestoUnitPrice, toRestoRateCardPayloadList } from './restoRateCardPayload';
import {
  calculateMainQuantityFromSmall,
  calculatePredictiveSmallQuantity,
  isValidRestoQuantityInput,
} from './restoStockQuantity';
import { getLinkRateCardDisabledReason, getLinkReductionUnits } from './restoLinkStock';
import DeleteIcon from '../ui/icons/Delete';
import Loader from "../global/loader/Loader";
import SnpComponent from "../global/SnpComponent";
import { SCREEN_INVENTORY } from "../../constants/VideoConstant";
import YouTubeVideo from "../global/YouTubeVideo";
import SingleFab from "../global/fab/SingleFab";
import SnpButton from "../global/SnpButton";
import EnterButton from "../global/EnterButton";
import DismissButton from "../global/DismissButton";
import utilities from "../../utilities/utilities";
import { useNavigate } from "react-router-dom";
import GlobalRestoBulkStock from "../dashboard/GlobalRestoBulkStock";
export default function RestoProductStock({ globalEditor = false, globalProductId = "", onGlobalEditorClose = () => {} }) {
  const storeApiUrl = useSelector(state => state.setApiUrlReducer.MAINURL.INITIAL_BASE_URL);
  const storeCartType = useSelector(state => state.setCartTypeReducer.cartType);
  const storeActiveShopHash = useSelector(state => state.setActiveShopHashReducer.activeShopHash);
  const navigate = useNavigate();

  const INITIAL_SNP_COMPONENT = {
    showDialog: false,
    outSideClickDismiss: true,
    title: "",
    subTitle: "",
    negativeAction: "",
    positiveAction: "",
    positiveReq: false,
    iconReq: false,
    snackBarOpen: false,
    snackBarMsg: "",
    cancelExtra: false,
    negativeReq: false,
    requestType: 0,
    handleSnpSubmit: null,
    handleSnpCancel: null,
    gui: "",
  };

  const INITIAL_RATE_CARD = {
    index: -1,
    name: "",
    sAmt: 0.0,
    smallUnitSAmt: 0.0,
    cAmt: 0.0,
    smallUnitCAmt: 0.0,
    id: "",
    serialNo: "",
    holdStock: false,
    hasStockEntries: false,
    gstInclusive: false
  };

  const INITIAL_CATEOGORY = {
    catgId: "",
    catgName: "",
  };

  const INITIAL_RESTO_STOCK_DATA = {
    id: "",
    catgId: "",
    catgName: "",
    itemStatus: ItemStatus.ACTIVE,
    prdName: "",
    displayName: "",
    productImage: [],
    spicy: Spicy.LESS_SPICY,
    foodType: FoodType.VEG,
    sgst: 2.5,
    cgst: 2.5,
    igst: 0.0,
    outOfStock: false,
    offertype: OfferType.No_Offer,
    offerAmt: 0.0,
    price: [],
    liveStockCount: "",
    ingredients: "",
    cartVisible: true,
    accountName: "",
    accountTitle: "",
    stockVisible: true,
  };

  const INITIAL_STOCK_DETAILS = {
    id: "",
    stockId: "", //Product Id
    stockName: "",
    supplierId: "",
    supplierName: "",
    billNo: "",
    mfgDate: "",
    expiryDate: "",
    sgst: 0.0,
    cgst: 0.0,
    custGstDisabled: false,
    fullPrice: 0.0,
    price: 0.0,
    liveStockCountStr: "",
    quantity: 0,
    smallQuantity: 0,
    taxMethod: false,
    productmrPrice: 0.0,
    offerDenom: OfferType.No_Offer,
    offerAmt: 0.0,
    productSellingPrice: 0.0,
    productWholeSalePrice: 0.0,
    sproductmrPrice: 0.0,
    purchasePrice: 0.0,
    sofferDenom: OfferType.No_Offer,
    sofferAmt: 0.0,
    sproductSellingPrice: 0.0,
    sproductWholeSalePrice: 0.0,
    buyerGstTaken: true,
    cnvId: "",
    unitName: "",
    unitCount: 1,
    unitRestrictions: false,
    smallUnitName: "",
    smallUnitCount: 0,
    decimalSmRestrictions: false,
    predictiveSmallQuantity: 0,
    isExpired: false,
    typeStr: "",
    type: 2,
    description: "",
    systemGenerated: false,
    createdAt: ""
  };

  const INITIAL_SUPPLIER = {
    supplierId: "",
    supplierName: "",
  };

  const INITIAL_LINK_STOCK = {
    id: "",
    stockId: "",
    stockName: "",
    linkedToId: "",
    linkedToName: "",
    smallQuantity: 0.0,
    reductionQuantity: 0.0,
    selectedUnit: "",
    linkedToConversionType: null,
    linkedToConversionTypeDetails: "",
  };

  const INITIAL_CONVERSION_SINGLE_DATA = {
    cnvId: "",
    unitName: "",
    unitRestrictions: false,
    smallUnitName: "",
    smallUnitCount: 1,
    decimalSmRestrictions: false,
  };

  const INITIAL_ITEM_DATA = {
    id: "",
    name: "",
  }


  const [paginationModel, setPaginationModel] = useState(INITIAL_PAGEMODEL);
  const [isDataLoaded, setDataLoaded] = useState(false);
  const [isRestoListLoading, setRestoListLoading] = useState(false);
  const [isDishSearchLoading, setDishSearchLoading] = useState(false);
  const [stockVisibilityFilter, setStockVisibilityFilter] = useState("visible");
  const [listViewMode, setListViewMode] = useState("table");
  const [cardPage, setCardPage] = useState(0);
  const [showDialog, setShowDialog] = useState(false);
  const [showStockDialog, setStockShowDialog] = useState(false);
  const [linkStockDialog, setLinkShowDialog] = useState(false);
  const [bulkStockDialog, setBulkStockDialog] = useState(false);
  const [dialogLoader, setDialogLoader] = useState(false);
  //const [deltedSuccessfully, setDelSuccess] = useState(false);
  const [isEditProduct, setEditProduct] = useState(false);
  const [restoData, setRestoData] = useState([]);
  const [baseRestoData, setBaseRestoData] = useState([]);
  const [categoryData, setCategoryData] = useState([]);
  const [imageSelectedError, setImageSelectedError] = useState(false);
  const [uploadedDocument, setUploadedDocument] = useState("");
  const [selectedRateCard, setSelectedRateCard] = useState(INITIAL_RATE_CARD);
  const [rateCard, setRateCard] = useState([]);
  const [selectedCategory, setSelectedcategory] = useState(INITIAL_CATEOGORY);
  const [restoSingleData, setRestoSingleData] = useState(INITIAL_RESTO_STOCK_DATA);
  const [showTable, setShowTable] = useState(false);
  const [showRateCardEditor, setShowRateCardEditor] = useState(false);
  const [selectedImage, setSelectedImage] = useState('');
  const [itemWiseOffer, setItemWiseOffer] = useState(false);
  const [ecartApp, setEcartApp] = useState(false);
  const [stockPricingFeature, setStockPricingFeature] = useState(false);
  const [configuredGst, setConfiguredGst] = useState({ cgst: 2.5, sgst: 2.5 });
  const [foodItemData, setFoodItemData] = useState([]);
  const [suggestedFoodItem, setSuggestedFoodItem] = useState([])
  const [suggestedFoodItemDeleted, setSuggestedFoodItemDeleted] = useState([])
  const [suggestionAvail, setSuggAvail] = useState(false);
  const [itemData, setItemData] = useState(INITIAL_ITEM_DATA);
  const [supplierData, setSupplierData] = useState(INITIAL_SUPPLIER);
  const [stockSingleData, setStockData] = useState(INITIAL_STOCK_DETAILS);
  const [listStockData, setListStockData] = useState([]);
  const [listSupplierData, setListSupplierData] = useState([]);
  const [isLoader, setLoader] = useState(false);
  const [snpComponent, setSnpComponent] = useState(INITIAL_SNP_COMPONENT);
  const [conversionSingleData, setConversionSingleData] = useState(INITIAL_CONVERSION_SINGLE_DATA);
  const [conversionTypeData, setConversionTypeData] = useState([]);
  const [choiceUnit, setChoiceUnit] = useState({
    unitChecked: false,
    smallUnitChecked: false,
  });
  const [linkSingleData, setLinkSingleData] = useState(INITIAL_LINK_STOCK);
  const [itemMultiAcc, setItemMultiAcc] = useState(false);
  const [listAcc, setListAcc] = useState([]);
  const [videoModel, setVideoModel] = useState({ show: false, path: "" });
  const [inputValue, setInputValue] = useState('');
  const [dishSearchValue, setDishSearchValue] = useState('');
  const dishSearchTimerRef = useRef(null);
  const dishSearchRequestRef = useRef(0);
  const [linkRateCardOptions, setLinkRateCardOptions] = useState([]);
  const [isLinkRateCardLoading, setLinkRateCardLoading] = useState(false);
  const linkRateCardSearchTimerRef = useRef(null);
  const linkRateCardSearchRequestRef = useRef(0);

  useEffect(() => () => {
    if (dishSearchTimerRef.current) clearTimeout(dishSearchTimerRef.current);
    dishSearchRequestRef.current += 1;
    if (linkRateCardSearchTimerRef.current) clearTimeout(linkRateCardSearchTimerRef.current);
    linkRateCardSearchRequestRef.current += 1;
  }, []);

  const stockManagementEnabled = isFeatureAllowed(STOCKMGMT);
  const listLoading = isRestoListLoading || isDishSearchLoading;
  const selectedRateCardConversion = stockManagementEnabled
    ? conversionTypeData.find((option) => option.id === selectedRateCard.conversionType?.id) || null
    : null;

  const handleRateCardTaxMethodChange = (event) => {
    const gstInclusive = event.target.value === 'true';
    if (gstInclusive === selectedRateCard.gstInclusive) return;
    const gstMultiplier = 1 + (Number(configuredGst.cgst) + Number(configuredGst.sgst)) / 100;
    const currentPrice = Number(selectedRateCard.sAmt) || 0;
    const currentSmallUnitPrice = Number(selectedRateCard.smallUnitSAmt) || 0;
    setSelectedRateCard({
      ...selectedRateCard,
      gstInclusive,
      sAmt: currentPrice === 0
        ? currentPrice
        : (gstInclusive ? currentPrice * gstMultiplier : currentPrice / gstMultiplier).toFixed(2),
      smallUnitSAmt: currentSmallUnitPrice === 0
        ? currentSmallUnitPrice
        : (gstInclusive ? currentSmallUnitPrice * gstMultiplier : currentSmallUnitPrice / gstMultiplier).toFixed(2),
    });
  };

  const getRateCardGstBreakdown = (price = selectedRateCard.sAmt) => {
    const enteredPrice = Number(price) || 0;
    const cgstRate = Number(configuredGst.cgst) || 0;
    const sgstRate = Number(configuredGst.sgst) || 0;
    const multiplier = 1 + (cgstRate + sgstRate) / 100;
    const basePrice = selectedRateCard.gstInclusive ? enteredPrice / multiplier : enteredPrice;
    const cgstAmount = basePrice * cgstRate / 100;
    const sgstAmount = basePrice * sgstRate / 100;
    return {
      basePrice: basePrice.toFixed(2),
      cgstAmount: cgstAmount.toFixed(2),
      sgstAmount: sgstAmount.toFixed(2),
      finalPrice: (basePrice + cgstAmount + sgstAmount).toFixed(2),
    };
  };

  const handleItemSearchChange = (event) => {
    if (event)
      setInputValue(event.target.value);
  }

  const handleSelectChange = (event, catg) => {
    if (catg != null) {
      //console.log("handleSelectChange", catg, catg.catgId, catg.catgName);
      setSelectedcategory({ ...selectedCategory, catgId: catg.catgId, catgName: catg.catgName })
      setRestoSingleData({ ...restoSingleData, ...selectedCategory })
    }
    //console.log("handleSelectChange-> ",restoSingleData);
  };

  const handleSubmitRate = async () => {
    if (await validateRateCardSerialNo(selectedRateCard.serialNo)) {
      const gstMultiplier = 1 + (Number(configuredGst.cgst) + Number(configuredGst.sgst)) / 100;
      const normalizedRate = {
        ...selectedRateCard,
        sAmt: selectedRateCard.gstInclusive
          ? Number((Number(selectedRateCard.sAmt) / gstMultiplier).toFixed(2))
          : Number(selectedRateCard.sAmt),
        smallUnitSAmt: selectedRateCard.gstInclusive
          ? Number((Number(selectedRateCard.smallUnitSAmt) / gstMultiplier).toFixed(2))
          : Number(selectedRateCard.smallUnitSAmt),
        gstInclusive: undefined,
      };
      setRateCard([
        ...rateCard, normalizedRate
      ]);
      setSelectedRateCard(INITIAL_RATE_CARD);
      setShowTable(true);
      setShowRateCardEditor(false);
    }
  };

  //on edit icon click for rate name
  const handleSelectListChange = (val, index) => {
    //console.log("handleSelectListChange", val, index);
    printDebugLog("handleSelectListChange", val, index);
    setSelectedRateCard({
      ...INITIAL_RATE_CARD,
      ...val,
      index,
      gstInclusive: false,
    });
    setShowRateCardEditor(true);
  };

  const handleDeleteRateCard = (event) => {
    if (selectedRateCard.hasStockEntries) {
      setSnpComponent((current) => ({
        ...current,
        snackBarOpen: true,
        snackBarMsg: "Rate Card cannot be deleted after stock has been added",
      }));
      return;
    }
    var rateCardCopy = [...rateCard];
    if (selectedRateCard.index >= 0 && rateCard[selectedRateCard.index]) {
      rateCardCopy.splice(selectedRateCard.index, 1);
      setRateCard([...rateCardCopy]);
    }
    setSelectedRateCard(INITIAL_RATE_CARD);
    setShowRateCardEditor(false);
  }

  const handleEditRate = async () => {
    if (await validateRateCardSerialNo(selectedRateCard.serialNo, selectedRateCard.index)) {
      const gstMultiplier = 1 + (Number(configuredGst.cgst) + Number(configuredGst.sgst)) / 100;
      const normalizedRate = {
        ...selectedRateCard,
        sAmt: selectedRateCard.gstInclusive
          ? Number((Number(selectedRateCard.sAmt) / gstMultiplier).toFixed(2))
          : Number(selectedRateCard.sAmt),
        smallUnitSAmt: selectedRateCard.gstInclusive
          ? Number((Number(selectedRateCard.smallUnitSAmt) / gstMultiplier).toFixed(2))
          : Number(selectedRateCard.smallUnitSAmt),
        gstInclusive: undefined,
      };
      let rateCardCopy = rateCard;
      if (selectedRateCard.index >= 0 && rateCard[selectedRateCard.index]) {
        rateCardCopy[[selectedRateCard.index]] = normalizedRate
        setRateCard([...rateCardCopy]);
      }
      setSelectedRateCard(INITIAL_RATE_CARD);
      setShowRateCardEditor(false);
    }
  }

  const handleInputChange = (event) => {
    //console.log("handleInputChange",event);
    const { name, value } = event.target;
    // console.log("handleInputChange", name, value);
    if (name === 'imgPath') {
      let file = event.target.files[0];
      setUploadedDocument(file);
      if (file) {
        setImageSelectedError(false);
        const reader = new FileReader();
        const url = reader.readAsDataURL(file);
        //console.log('VN Data', reader.result,url)
        printDebugLog("handleInputChange", url);
        reader.onloadend = function (e) {
          //console.log('VN ssData', reader.result,url)
          setSelectedImage(reader.result)
        }
      } else {
        setSelectedImage('')
        setImageSelectedError(true);
      }
    } else if (name === 'name' || name === 'cAmt' || name === 'smallUnitCAmt' || name === 'sAmt' || name === 'smallUnitSAmt' || name === 'serialNo') {
      setSelectedRateCard(prev => ({
        ...prev,
        [name]: value,
      }));
    } else if (name === 'itemStatus') {
      const num = Number(value);
      setRestoSingleData({
        ...restoSingleData,
        itemStatus: num,
        cartVisible: (num === ItemStatus.ACTIVE) ? true : false,
      });
    } else if (name === 'unitChecked') {
      const previousCheckedValue = choiceUnit.unitChecked;
      setChoiceUnit({
        ...choiceUnit,
        unitChecked: !previousCheckedValue,
      });
      setStockData({
        ...stockSingleData,
        quantity: 0,
      });
    } else if (name === 'smallUnitChecked') {
      let previousCheckedValue = choiceUnit.smallUnitChecked;
      setChoiceUnit({
        ...choiceUnit,
        smallUnitChecked: !previousCheckedValue,
      });
      setStockData({
        ...stockSingleData,
        smallQuantity: 0,
      });
    } else if (name === 'outOfStock') {
      let previousCheckedValue = restoSingleData.outOfStock;
      setRestoSingleData({
        ...restoSingleData,
        outOfStock: !previousCheckedValue,
      });
    } else {
      setRestoSingleData({
        ...restoSingleData,
        [name]: value,
      });
    }
    //console.log("setRestoSingleData-> ",restoSingleData);
  };

  const calculateRateCardPrice = (sourceField, targetField, targetUnit) => {
    if (!selectedRateCardConversion || selectedRateCardConversion.unitRestrictions) return;
    setSelectedRateCard((current) => ({
      ...current,
      [targetField]: calculateRestoUnitPrice(current[sourceField], selectedRateCardConversion, targetUnit),
    }));
  };

  const handleSnackClose = () => {
    setSnpComponent({
      ...snpComponent,
      snackBarOpen: false,
      snackBarMsg: "",
    });
  };

  const handleSupplierChange = (event, option) => {
    if (option != null) {
      //console.log("handleSupplierChange", event, option);
      setSupplierData({
        ...supplierData,
        supplierId: option.supplierId,
        supplierName: option.supplierName
      });
      setStockData({
        ...stockSingleData, supplierId: option.supplierId,
        supplierName: option.supplierName
      });
    }
  };

  const getCustomUnitDetails = (option) => {
    let data = "";
    printDebugLog("getCustomUnitDetails", option);
    if (null === option || undefined === option)
      return data;
    if (option.id === 'cr')
      data = option.unitName;
    else {
      if (option.unitName) {
        if (option.unitRestrictions) {
          if (option.smallUnitCount > 0 && option.smallUnitName)
            data = "Only " + option.unitName + "(" + option.smallUnitCount + " " + option.smallUnitName + ")";
          else
            data = "Only " + option.unitName;
        } else {
          data = option.unitName + "=" + option.smallUnitCount + " " + option.smallUnitName;
        }
      }
    }
    return data;
  };

  const getQuantityDetails = (val) => {
    let resp = val.quantity + " " + val.unitName;
    if (!val.unitRestrictions)
      resp = resp + "/" + val.smallQuantity + " " + val.smallUnitName;
    return resp;
  };


  const handleSelectStock = (option) => {
    setConversionSingleData({
      ...conversionSingleData,
      cnvId: option.cnvId,
      unitName: option.unitName,
      unitCount: option.unitCount,
      unitRestrictions: option.unitRestrictions,
      smallUnitName: option.smallUnitName,
      smallUnitCount: option.smallUnitCount,
      decimalSmRestrictions: option.decimalSmRestrictions,
    });
    setStockData(option);
    setSupplierData({
      ...supplierData,
      supplierId: option.supplierId,
      supplierName: option.supplierName
    });
    if (option.unitRestrictions) {
      setChoiceUnit({
        ...choiceUnit,
        unitChecked: true,
        smallUnitChecked: false,
      })
    } else {
      setChoiceUnit({
        ...choiceUnit,
        unitChecked: true,
        smallUnitChecked: false,
      })
    }
    setEditProduct(true);
  }



  const handleConversionChange = (event, option) => {
    if (option != null) {
      setConversionSingleData({
        ...conversionSingleData,
        cnvId: option.id,
        unitName: option.unitName,
        unitCount: option.unitCount,
        unitRestrictions: option.unitRestrictions,
        smallUnitName: option.smallUnitName,
        smallUnitCount: option.smallUnitCount,
        decimalSmRestrictions: option.decimalSmRestrictions,
      });
      setStockData({
        ...stockSingleData,
        cnvId: option.id,
        unitName: option.unitName,
        unitCount: option.unitCount,
        unitRestrictions: option.unitRestrictions,
        smallUnitName: option.smallUnitName,
        smallUnitCount: option.smallUnitCount,
        decimalSmRestrictions: option.decimalSmRestrictions,
        quantity: 0,
        smallQuantity: 0,
        predictiveSmallQuantity: 0,
      });
      if (option.unitRestrictions) {
        setChoiceUnit({
          ...choiceUnit,
          unitChecked: true,
          smallUnitChecked: false,
        })
      } else {
        setChoiceUnit({
          ...choiceUnit,
          unitChecked: true,
          smallUnitChecked: true,
        })
      }
    } else {
      setConversionSingleData(INITIAL_CONVERSION_SINGLE_DATA);
      setStockData({
        ...stockSingleData,
        cnvId: "",
        unitName: "",
        unitCount: 0,
        unitRestrictions: false,
        smallUnitName: "",
        smallUnitCount: 0,
        decimalSmRestrictions: false,
        predictiveSmallQuantity: 0,
      });
      setChoiceUnit({
        ...choiceUnit,
        unitChecked: false,
        smallUnitChecked: false,
      })
    }
  };


  const validateRateCardSerialNo = async (serialNo, editingIndex = -1) => {
    try {
      if (isEmpty(serialNo)) {
        return true;
      }
      const normalizedSerialNo = String(serialNo).trim();
      const originalRateCard = editingIndex >= 0 ? rateCard[editingIndex] : null;
      if (originalRateCard && String(originalRateCard.serialNo || '').trim() === normalizedSerialNo) {
        return true;
      }
      const duplicateInCurrentItem = rateCard.some((item, index) =>
        index !== editingIndex && String(item.serialNo || '').trim() === normalizedSerialNo
      );
      if (duplicateInCurrentItem) {
        setSnpComponent(prev => ({
          ...prev, snackBarMsg: `Serial no ${normalizedSerialNo} is already used in this item`, snackBarOpen: true,
        }));
        return false;
      }
      setLoader(true);
      const response = await snpAxios.get(`${storeApiUrl.BACKEND_BASE_URL}${getPreUrlAccordingToCart(storeActiveShopHash.cartType)}validate-rate-card-serial-no?s=${storeActiveShopHash.id}&q=${encodeURIComponent(normalizedSerialNo)}`);
      if (response.data.status === SUCCESS) {
        setLoader(false);
        return true;
      } else {
        setLoader(false);
        setSnpComponent(prev => ({
          ...prev, snackBarMsg: `Serial no ${normalizedSerialNo} is already used`, snackBarOpen: true,
        }))
        return false;
      }
    } catch (errr) {
      setLoader(false);
      console.error("validateRateCardSerialNo", errr);
    }
    return false;
  }

  const getFoodItemsViaId = (id, rateCardId = "") => {
    let foodUrl = storeApiUrl.BACKEND_BASE_URL + getPreUrlAccordingToCart(storeActiveShopHash.cartType) + FOODIMAGEVIAID + `?&token=${getAuthSession().apiToken}`
      + `&id=${id}`;
    let data = {};
    printDebugLog("getFoodItemsViaId<=", foodUrl);
    axios.get(
      foodUrl,
      data
    )
      .then((response) => {
        printDebugLog("getFoodItemsViaId=>", response.data);
        setLoader(false);
        if (response.data.status === SUCCESS) {
          setEditProduct(true);
          setSelectedcategory({
            ...selectedCategory,
            catgId: response.data.jcJson.catgId,
            catgName: response.data.jcJson.catgName
          })
          setRestoSingleData({
            ...restoSingleData,
            itemStatus: response.data.jcJson.itemStatus,
            prdName: response.data.jcJson.name,
            displayName: response.data.jcJson.displayName,
            ingredients: response.data.jcJson.ingredients,
            brandName: response.data.jcJson.brandName,
            id: response.data.jcJson.id,
            productImage: response.data.jcJson.productImage,
            catgId: response.data.jcJson.catgId,
            catgName: response.data.jcJson.catgName,
            price: response.data.jcJson.price,
            spicy: response.data.jcJson.spicy,
            foodType: response.data.jcJson.foodType,
            sgst: response.data.jcJson.sgst,
            cgst: response.data.jcJson.cgst,
            igst: 0.0,
            outOfStock: response.data.jcJson.outOfStock,
            offertype: response.data.jcJson.offertype,
            offerAmt: response.data.jcJson.offerAmt,
            liveStockCount: response.data.jcJson.liveStockCount,
            cartVisible: response.data.jcJson.cartVisible,
            stockVisible: response.data.jcJson.stockVisible,
            accountTitle: response.data.jcJson.accountName,
            accountName: response.data.jcJson.accountName,
          })
          setRateCard(response.data.jcJson.price);
          const rateCardIndex = response.data.jcJson.price.findIndex((card) => card.id === rateCardId);
          if (rateCardIndex >= 0) {
            setSelectedRateCard({ ...response.data.jcJson.price[rateCardIndex], index: rateCardIndex, gstInclusive: false });
            setShowRateCardEditor(true);
          }
          setShowTable(true);
          if (response.data.jcJson.listItemSuggestion.length > 0) {
            setSuggAvail(true);
            setSuggestedFoodItem(response.data.jcJson.listItemSuggestion);
          }
          setShowDialog(true);
        }
      }).catch((error) => {
        setLoader(false);
        printInfoLog("error : ", error);
        //window.location.href = "#/error";
      });
  }

  const handleDeleteImage = (index) => {
    let path = restoSingleData.productImage[index];
    let cUrl = storeApiUrl.BACKEND_BASE_URL + getPreUrlAccordingToCart(storeActiveShopHash.cartType) + DELETEIMAGE + `?productHash=${restoSingleData.id}`
      + `&path=${path}`;
    let data = {};
    setDialogLoader(true);
    printDebugLog("handleDeleteImage<=", cUrl);
    axios.get(
      cUrl,
      data
    )
      .then((response) => {
        printDebugLog("handleDeleteImage=>", response.data);
        setDialogLoader(false);
        if (response.data.status === SUCCESS) {
          // If item is found, create a new array without it
          if (index !== -1) {
            let images = restoSingleData.productImage;
            const updatedItems = [...images.slice(0, index), ...images.slice(index + 1)];
            setRestoSingleData({
              ...restoSingleData,
              productImage: updatedItems,
            })
            setSnpComponent({
              ...snpComponent, snackBarMsg: "Image removed successfull ... Updating Items",
              snackBarOpen: true,
            })
            setShowDialog(false);
            getRestoDetails();

          }
        }
      }).catch((error) => {
        setDialogLoader(false);
        printInfoLog("error : ", error);
        //window.location.href = "#/error";
      });
  }
  const getAllAccountName = () => {
    let cartUrl = storeApiUrl.BACKEND_BASE_URL + "accounting/get-account-names";
    let data = {
      jcJson: {
        shopHash: storeActiveShopHash.id,
        apiToken: getAuthSession().apiToken,
      }
    };
    setLoader(true);
    snpAxios.post(
      cartUrl,
      data
    )
      .then((response) => {
        //printLog("getAllAccountName response  => ", response.data);
        setLoader(false);
        if (response.data.status === SUCCESS) {
          const updatedList = [...response.data.jcJson.listAcc, 'Other'];
          setListAcc(updatedList);
        }
      }).catch((error) => {
        printDebugLog("getAllAccountName errr ", error);
        setLoader(false);
        //window.location.href = "#/error";
      });
  };

  useEffect(() => {
    if (globalEditor && globalProductId) {
      setLoader(true);
      getFoodItemsViaId(globalProductId);
    }
  }, [globalEditor, globalProductId]);

  const getSingleConfigs = (mConfigName) => {
    let cUrl = storeApiUrl.BACKEND_BASE_URL + getPreUrlAccordingToCart(storeActiveShopHash.cartType) + GETSINGLECONFIGS + `?adminId=${getAuthSession().apiToken}`
      + `&configName=${mConfigName}&shopHash=${storeActiveShopHash.id}`;
    let data = {};
    //const urlFormattedString = encodeURIComponent(cUrl);
    //console.log("getSingleConfigs => ", cUrl);
    axios.get(
      cUrl,
      data
    )
      .then((response) => {
        //console.log("getSingleConfigs<=",response.data);
        if (response.data !== '') {
          if (mConfigName === ITEMWISEOFFER)
            setItemWiseOffer(response.data === 'Yes')
          else if (mConfigName === ECARTAPP)
            setEcartApp(response.data === 'Yes');
          else if (mConfigName === STOCKPRICINGFEATURE)
            setStockPricingFeature(response.data === 'Yes');
          else if (mConfigName === ITEM_CGST || mConfigName === ITEM_SGST) {
            const rawGstValue = response.data == null ? '' : String(response.data).trim();
            const parsedGstValue = rawGstValue === '' ? NaN : Number(rawGstValue);
            if (!Number.isFinite(parsedGstValue) || parsedGstValue < 0) return;
            const gstValue = parsedGstValue;
            const field = mConfigName === ITEM_CGST ? 'cgst' : 'sgst';
            setConfiguredGst((current) => ({ ...current, [field]: gstValue }));
            if (!isEditProduct) setRestoSingleData((current) => ({ ...current, [field]: gstValue }));
          }
          else if (mConfigName === ITEMMULTIACCOUNT) {
            let responseData = (response.data === 'Yes');
            setItemMultiAcc(responseData);
            if (responseData) getAllAccountName();
          }
        }
      }).catch((error) => {
        console.log("error : ", error);
        //window.location.href = "#/error";
      });
  };
  const handleImageUpload = async () => {
    let isError = false;
    let check = true;
    if (isEditProduct && restoSingleData.productImage.length > 0) {
      if (!uploadedDocument) {
        check = false;
      }
    }
    if (rateCard.length === 0) {
      setSnpComponent({
        ...snpComponent,
        snackBarOpen: true,
        snackBarMsg: "Please Add Rate Card to Proceed",
      })
      isError = true;
    }
    if (check) {
      if (!uploadedDocument || uploadedDocument.size > 5242880 || !(uploadedDocument.type.includes("image"))) {    //5248256
        setImageSelectedError(true);
        isError = true;
      }
      if (!isError) {
        setDataLoaded(false);
        let formData = new FormData();
        formData.append('fnm', getAuthSession().apiToken);
        formData.append("file", uploadedDocument);
        await ImageUploadService.upload(storeApiUrl.BACKEND_BASE_URL, getPreUrlAccordingToCart(storeActiveShopHash.cartType), formData).then(response => {
          setUploadedDocument('');
          if (response.data.folderName) {
            setSnpComponent({
              ...snpComponent, snackBarMsg: "Image Uploaded Successfully ...", snackBarOpen: true,
            })
            printInfoLog("folderName", response.data.folderName, restoSingleData);
            if (!restoSingleData.productImage)
              restoSingleData.productImage = [];
            restoSingleData.productImage.push(response.data.folderName);
            handleSubmitResto();
          } else {
            setSnpComponent({
              ...snpComponent, snackBarMsg: "Failed to upload the image ...", snackBarOpen: true,
            })
            setDataLoaded(true);
            printDebugLog("response.data error", response.data);
          }

        }
        ).catch(error => {
          setDataLoaded(true);
          console.log("handleImageUpload = > ", error);
          handleSubmitResto();
          // window.location.href = "#/error";
        });
      }
    } else {
      handleSubmitResto();
    }
  };
  const getFoodType = (foodType) => {
    let data = "";
    if (foodType === FoodType.NONE)
      data = "None";
    else if (foodType === FoodType.VEG)
      data = "Veg";
    else if (foodType === FoodType.NON_VEG)
      data = "Non-Veg";
    else if (foodType === FoodType.EGG)
      data = "Egg";
    else if (foodType === FoodType.DRINK)
      data = "Drink";
    else if (foodType === FoodType.ICE_CREAM)
      data = "Ice-cream";
    else if (foodType === FoodType.SWEEETS)
      data = "Sweets";
    return data;
  };

  const columns = [
    {
      field: "productImage",
      headerName: "Image",
      width: 90,
      renderCell: (rowData) => (
        <div>
          <img
            alt=""
            style={{ height: "80px", width: "80px", borderRadius: "40%" }}
            src={storeApiUrl.BACKEND_BASE_URL + "files/" + rowData.row.productImage[0]}
          ></img>
        </div>
      ),
    },
    { field: 'catgName', headerName: 'Category', width: 170 },
    {
      field: 'name', headerName: 'Dish Name', width: 170
    },
    {
      field: 'foodTypeStr', headerName: 'Food Type', width: 100
    },
    {
      field: 'itemStatusStr', headerName: 'Status', width: 120, valueGetter: (params) => params.row.itemStatusStr, renderCell: (params) => (
        <span style={{ color: params.value === 'Active' ? '#0f633b' : "#7a1904" }}>{params.value}</span>
      ),
    },
    {
      field: "edit",
      headerName: "Edit",
      width: 90,
      renderCell: (cellValues) => {
        return (
          <EditIcon
            onClick={(event) => {
              if (isRoleAllowed(STOCKMGMT, ROLE_UPDATE)) {
                handleCellClick(event, cellValues, false);
              } else {
                setSnpComponent({
                  ...snpComponent,
                  isLoader: false,
                  negativeReq: false,
                  positiveReq: true,
                  positiveAction: "Ok Got it",
                  showDialog: true,
                  outSideClickDismiss: true,
                  cancelExtra: true,
                  requestType: 99,
                  subTitle: "You Are not allowed to Add/Update Stock Details.Contact the Owner",
                  handleSnpSubmit: () => setSnpComponent(INITIAL_SNP_COMPONENT),
                });
              }

            }}
          >
          </EditIcon>
        );
      }
    }
  ];

  const columnsWithStock = [
    {
      field: "productImage",
      headerName: "Image",
      width: 90,
      renderCell: (rowData) => (
        <div>
          <img
            alt=""
            style={{ height: "80px", width: "80px", borderRadius: "40%" }}
            src={storeApiUrl.BACKEND_BASE_URL + "files/" + rowData.row.productImage[0]}
          ></img>
        </div>
      ),
    },
    { field: 'catgName', headerName: 'Category', width: 100 },
    {
      field: 'foodTypeStr', headerName: 'Food\nType', width: 100
    },
    {
      field: 'name', headerName: 'Dish Name', width: 170
    },
    { field: 'foodQuantityName', headerName: 'Food\nQuantity Name', width: 210 },
    { field: 'sellingPrice', headerName: 'Price', width: 70 },
    {
      field: "edit",
      headerName: "Edit",
      width: 40,
      renderCell: (cellValues) => {
        return (
          <EditIcon
            onClick={(event) => {
              if (isRoleAllowed(STOCKMGMT, ROLE_UPDATE)) {
                handleCellClick(event, cellValues, false);
              } else {
                setSnpComponent({
                  ...snpComponent,
                  isLoader: false,
                  negativeReq: false,
                  positiveReq: true,
                  positiveAction: "Ok Got it",
                  showDialog: true,
                  outSideClickDismiss: true,
                  cancelExtra: true,
                  requestType: 99,
                  subTitle: "You Are not allowed to Add/Update Item Details.Contact the Owner",
                  handleSnpSubmit: () => setSnpComponent(INITIAL_SNP_COMPONENT),
                });
              }

            }}
          >
          </EditIcon>
        );
      }
    },
    { field: 'liveStockCount', headerName: 'S.Count', width: 100 },
    {
      field: "add",
      headerName: "Add Stock",
      width: 50,
      renderCell: (cellValues) => {
        return (
          <InventoryIcon
            onClick={(event) => {
              if (isRoleAllowed(STOCKMGMT, ROLE_UPDATE)) {
                handleCellClick(event, cellValues, true);
              } else {
                setSnpComponent({
                  ...snpComponent,
                  isLoader: false,
                  negativeReq: false,
                  positiveReq: true,
                  positiveAction: "Ok Got it",
                  showDialog: true,
                  outSideClickDismiss: true,
                  cancelExtra: true,
                  requestType: 99,
                  subTitle: "You Are not allowed to Add/Update Stock Details.Contact the Owner",
                  handleSnpSubmit: () => setSnpComponent(INITIAL_SNP_COMPONENT),
                });
              }

            }}
          >
          </InventoryIcon>
        );
      }
    },
    {
      field: "link",
      headerName: "Link Stock",
      width: 100,
      renderCell: (e) => {
        return (
          <AddLinkIcon
            onClick={(event) => {
              if (isRoleAllowed(STOCKMGMT, ROLE_UPDATE)) {
                handleGetLinkStock(e.row.id);
              } else {
                setSnpComponent({
                  ...snpComponent,
                  isLoader: false,
                  negativeReq: false,
                  positiveReq: true,
                  positiveAction: "Ok Got it",
                  showDialog: true,
                  outSideClickDismiss: true,
                  cancelExtra: true,
                  requestType: 99,
                  subTitle: "You Are not allowed to Add/Update Stock Details.Contact the Owner",
                  handleSnpSubmit: () => setSnpComponent(INITIAL_SNP_COMPONENT),
                });
              }

            }}
          >
          </AddLinkIcon>
        );
      }
    },
    {
      field: 'itemStatusStr', headerName: 'Status', width: 90, valueGetter: (params) => params.row.itemStatusStr, renderCell: (params) => (
        <span style={{ color: params.value === 'Active' ? '#0f633b' : "#7a1904" }}>{params.value}</span>
      ),
    },
    {field: 'stockVisibleStr', headerName: 'Visible To Billing', width: 140 },
  ];



  const loadStockConversionDetails = async (row) => {
    const productId = row.productId || row.id;
    const foodUrl = storeApiUrl.BACKEND_BASE_URL
      + getPreUrlAccordingToCart(storeActiveShopHash.cartType) + FOODIMAGEVIAID
      + `?token=${getAuthSession().apiToken}&id=${productId}`;
    setLoader(true);
    try {
      const response = await axios.get(foodUrl, {});
      const product = response.data.status === SUCCESS ? response.data.jcJson : null;
      const selectedCard = product?.price?.find((card) => card.id === row.id);
      const conversion = selectedCard?.conversionType;
      if (!conversion) {
        setLoader(false);
        setSnpComponent((current) => ({
          ...current,
          snackBarOpen: true,
          snackBarMsg: "Conversion details are not configured for this Rate Card",
        }));
        return;
      }
      const stockConversion = {
        ...conversion,
        cnvId: conversion.cnvId || conversion.id,
      };
      setRestoSingleData((current) => ({
        ...current,
        ...row,
        prdName: product.name || row.name,
        foodQuantityName: selectedCard.foodQuantityName || row.foodQuantityName,
      }));
      setConversionSingleData((current) => ({ ...current, ...stockConversion }));
      setStockData((current) => ({
        ...current,
        cnvId: stockConversion.cnvId,
        unitName: stockConversion.unitName,
        unitCount: stockConversion.unitCount,
        unitRestrictions: stockConversion.unitRestrictions,
        smallUnitName: stockConversion.smallUnitName,
        smallUnitCount: stockConversion.smallUnitCount,
        decimalSmRestrictions: stockConversion.decimalSmRestrictions,
      }));
      getStockData(row.id);
    } catch (error) {
      setLoader(false);
      printInfoLog("Unable to load stock conversion details: ", error);
      setSnpComponent((current) => ({
        ...current,
        snackBarOpen: true,
        snackBarMsg: "Unable to load the Rate Card details for Add Stock",
      }));
    }
  };

  const handleCellClick = (param, event, lookStock) => {
    printDebugLog("handleCellClick", event.row);
    if (!lookStock) {
      setLoader(true);
      getFoodItemsViaId(event.row.productId, event.row.id);
    } else if (event.row.conversionType?.cnvId || event.row.conversionType?.id) {
      setRestoSingleData({
        ...restoSingleData, ...event.row,
        prdName: event.row.name
      })
      setConversionSingleData({
        ...conversionSingleData, ...event.row.conversionType,
        cnvId: event.row.conversionType.cnvId || event.row.conversionType.id,
      });
      getStockData(event.row.id);
    } else {
      loadStockConversionDetails(event.row);
    }
  };

  const clearProductData = () => {
    setRateCard([]);
    setSelectedRateCard(INITIAL_RATE_CARD)
    setShowRateCardEditor(false);
    setSelectedcategory(INITIAL_CATEOGORY)
    setRestoSingleData({ ...INITIAL_RESTO_STOCK_DATA, ...configuredGst });
    setSelectedImage('');
  }

  const handleSubmitResto = async () => {
    if (rateCard.length > 0) {
      setDataLoaded(false);
      let catgUrl = storeApiUrl.BACKEND_BASE_URL + getPreUrlAccordingToCart(storeActiveShopHash.cartType) + SET_RESTAURANT_DATA;
      const rateCardPayload = toRestoRateCardPayloadList(rateCard);
      let suggestionData = "";
      if (!isEmpty(suggestedFoodItem))
        suggestionData = suggestedFoodItem.map(item => { return item.foodItemId });

      let filledData = {
        jcJson: {
          apiToken: getAuthSession().apiToken,
          catgId: selectedCategory.catgId,
          catgName: selectedCategory.catgName,
          ingredients: restoSingleData.ingredients,
          itemStatus: Number(restoSingleData.itemStatus),
          name: restoSingleData.prdName,
          displayName: restoSingleData.displayName,
          productImage: restoSingleData.productImage,
          id: restoSingleData.id,
          price: rateCardPayload,
          foodType: parseInt(restoSingleData.foodType),
          spicy: parseInt(restoSingleData.spicy),
          outOfStock: restoSingleData.outOfStock,
          offertype: parseInt(restoSingleData.offertype),
          offerAmt: parseFloat(restoSingleData.offerAmt),
          sgst: parseFloat(restoSingleData.sgst),
          cgst: parseFloat(restoSingleData.cgst),
          shopHash: storeActiveShopHash.id,
          cartVisible: restoSingleData.cartVisible,
          listItemSuggestion: suggestionData,
          delListItemSuggestion: suggestedFoodItemDeleted,
          accountName: restoSingleData.accountName,
          stockVisible: restoSingleData.stockVisible,
        }
      };
      try {
        const response = await snpAxios.post(catgUrl, filledData);
        if (response.data.status === SUCCESS) {
          if (!isEmpty(filledData.jcJson.accountName)) getAllAccountName();
          handleDialogClose();
          setShowTable(false);
          setSelectedImage('');
          getRestoDetails();
        } else {
          setDataLoaded(true);
        }
      } catch (error) {
        console.log("error : ", error);
        setDataLoaded(true);
      }
    } else {
      setSnpComponent({
        ...snpComponent,
        snackBarOpen: true,
        snackBarMsg: "Please Enter Price to Proceed",
      })
    }

  };
  //const [paginationModel, setPaginationModel] = useState(INITIAL_PAGEMODEL);
  const getRestoDetails = async (visibilityFilter = stockVisibilityFilter) => {
    //let cartUrl = storeApiUrl.BACKEND_BASE_URL + getPreUrlAccordingToCart(storeActiveShopHash.cartType) + GET_RESTAURANT_DATA+"/"+pageData.page+"/"+pageData.pageSize;
    let cartUrl = storeApiUrl.BACKEND_BASE_URL + getPreUrlAccordingToCart(storeActiveShopHash.cartType) + GET_RESTAURANT_DATA;
    let data = {
      jcJson: {
        apiToken: getAuthSession().apiToken,
        shopHash: storeActiveShopHash.id,
      }
    };
    if (visibilityFilter !== "all") {
      data.jcJson.stockVisible = visibilityFilter === "visible";
    }
    //  console.log("getRestoDetails  => ",data);
    //setDelSuccess(false);
    dishSearchRequestRef.current += 1;
    if (dishSearchTimerRef.current) clearTimeout(dishSearchTimerRef.current);
    setDishSearchValue('');
    setDishSearchLoading(false);
    setCardPage(0);
    setDataLoaded(false);
    setRestoListLoading(true);
    try {
      const response = await snpAxios.post(cartUrl, data);
      if (response.data.status === SUCCESS) {
        const items = response.data.jcJson.value_2 || [];
        setBaseRestoData(items);
        setRestoData(items);
      } else {
        setBaseRestoData([]);
        setRestoData([]);
      }
    } catch (error) {
      setBaseRestoData([]);
      setRestoData([]);
      console.log("errr ", error);
      //window.location.href = "#/error";
    } finally {
      setDataLoaded(true);
      setRestoListLoading(false);
    }
  };

  const handleStockVisibilityFilterChange = (nextFilter) => {
    if (nextFilter === stockVisibilityFilter || isRestoListLoading) return;
    setStockVisibilityFilter(nextFilter);
    setCardPage(0);
    setPaginationModel((current) => ({ ...current, page: 0 }));
    getRestoDetails(nextFilter);
  };

  const getCartDetails = async () => {
    let catgUrl = storeApiUrl.BACKEND_BASE_URL + getPreUrlAccordingToCart(storeCartType) + GET_CATEOGORY_DATA;

    let data = {
      jcJson: {
        apiToken: getAuthSession().apiToken,
        shopHash: storeActiveShopHash.id,
      }
    };
    //   console.log("verifyCredentials => ",data);
    snpAxios.post(
      catgUrl,
      data
    )
      .then((response) => {
        //console.log("VSN", response);
        if (response.data.status === SUCCESS) {
          //setCategoryData(response.data.jcJson.value_2);
          let resp = response.data.jcJson.value_2.map((catg) => {
            let catgName = catg.catgName
            let catgId = catg.id
            return { catgName, catgId }
          })
          // console.log("Resut : ", resp);
          setCategoryData(resp);
          //console.log(categoryData);
        }
      }).catch((error) => {
        console.log("getCartDetails ", error);
      });
  };

  const getYoutubeVideo = (videoName, lang) => {
    let cUrl = storeApiUrl.BACKEND_BASE_URL + getPreUrlAccordingToCart(storeActiveShopHash.cartType) + GETVIDEOPATH + `?adminId=${getAuthSession().apiToken}`
      + `&name=${videoName}&lang=${lang}`;
    let data = {};
    axios.get(
      cUrl,
      data
    )
      .then((response) => {
        //printLog("getSingleConfigs<=",response.data);
        if (response.data !== '') {
          setVideoModel({ ...videoModel, path: response.data });
        } else
          setVideoModel({ ...videoModel, path: '' });
      }).catch((error) => {
        //printLog("error : ", error);
        //window.location.href = "#/error";
        setVideoModel({ ...videoModel, path: '' });
      });
  };
  useLayoutEffect(() => {
    //  console.log('Printing Login Details : ',getAuthSession);
    getSingleConfigs(ITEMWISEOFFER);
    getSingleConfigs(ITEM_CGST);
    getSingleConfigs(ITEM_SGST);
    if (isFeatureAllowed(THEMEMGMT)) {
      getSingleConfigs(ECARTAPP);
    }
    getCartDetails();
    getSingleConfigs(ITEMMULTIACCOUNT);
    if (globalEditor) {
      if (stockManagementEnabled) getConversionData();
      return;
    }
    getYoutubeVideo(SCREEN_INVENTORY, 'hi');
    getRestoDetails();
    if (stockManagementEnabled) {
      getSingleConfigs(STOCKPRICINGFEATURE);
      getConversionData();
      if (isFeatureAllowed(SUPMGMT))
        getSupplierDetails();
    }
  }, [storeCartType, storeActiveShopHash, storeApiUrl]);

  const handleFoodItemsSearch = (event) => {
    const value = event.target.value;
    //console.log("handleQuickItemsSearch",value)
    if (value.length >= 3) {
      getAllFoodItem(value);
    }
  };

  const getAllFoodItem = async (regextStr) => {
    if (isEmpty(regextStr))
      return;
    let encodedHash = utilities.encode(storeActiveShopHash.id);
    let fetchBillUrl = storeApiUrl.BACKEND_BASE_URL + getPreUrlAccordingToCart(storeActiveShopHash.cartType) + GETFOODITEMSUGGESTION + "?s=" + encodedHash + "&q=" + regextStr;
    let data = {};
    axios.get(
      fetchBillUrl,
      data
    )
      .then((response) => {
        printDebugLog("getAllFoodItem", response.data);
        if (response.data.status === SUCCESS) {
          setFoodItemData(response.data.jcJson.listItemSuggestion);
        }
      })
      .catch((error) => {
        printDebugLog("Error : ", error);
      });
  };

  const getSupplierDetails = async () => {
    let cartUrl = storeApiUrl.BACKEND_BASE_URL + getPreUrlAccordingToCart(storeCartType) + GET_SUPPLIER_FEW_DATA;
    let data = {
      jcJson: {
        apiToken: getAuthSession().apiToken,
        shopHash: storeActiveShopHash.id,
      }
    };
    //  console.log("getSupplierDetails  => ",data);
    snpAxios.post(
      cartUrl,
      data
    )
      .then((response) => {
        printDebugLog("response  => ", response.data);
        if (response.data.status === SUCCESS) {
          setListSupplierData(response.data.jcJson.value_2);
        }
      }).catch((error) => {
        console.log("errr ", error);
        //window.location.href = "#/error";
      });
  };

  const getConversionData = async () => {
    let catgUrl = storeApiUrl.BACKEND_BASE_URL + getPreUrlAccordingToCart(storeCartType) + GET_CONVERSIONTYPE_DATA;
    let data = {
      jcJson: {
        apiToken: getAuthSession().apiToken,
        shopHash: storeActiveShopHash.id,
        createNew: stockPricingFeature,
      }
    };
    snpAxios.post(
      catgUrl,
      data
    )
      .then((response) => {
        printDebugLog("Conversion Data", response.data);
        if (response.data.status === SUCCESS) {
          setConversionTypeData(response.data.jcJson.value_2);
          if (!stockPricingFeature) {
            let firstData = response.data.jcJson.value_2[0];
            setConversionSingleData(firstData);
            setStockData({
              ...stockSingleData,
              cnvId: firstData.id,
              unitName: firstData.unitName,
              unitCount: firstData.unitCount,
              unitRestrictions: firstData.unitRestrictions,
              smallUnitName: firstData.smallUnitName,
              smallUnitCount: firstData.smallUnitCount,
              decimalSmRestrictions: firstData.decimalSmRestrictions,
            });
            if (firstData.unitRestrictions) {
              setChoiceUnit({
                ...choiceUnit,
                unitChecked: true, smallUnitChecked: false,
              })
            }

          }

        }
      }).catch((error) => {
        console.log("error : ", error);
        //window.location.href = "#/error";
      });
  };

  const getStockData = async (mStockId) => {
    let cartUrl = storeApiUrl.BACKEND_BASE_URL + GETRESTOSTOCKENTRY;
    let data = {
      jcJson: {
        apiToken: getAuthSession().apiToken,
        shopHash: storeActiveShopHash.id,
        stockId: mStockId,
        limit: 2,
      }
    };
    //  console.log("getSupplierDetails  => ",data);
    setLoader(true);
    snpAxios.post(
      cartUrl,
      data
    )
      .then((response) => {
        printDebugLog("response  => ", response.data);
        setLoader(false);
        setStockShowDialog(true);
        if (response.data.status === SUCCESS) {
          setListStockData(response.data.jcJson.value_2);
        }
      }).catch((error) => {
        setLoader(false);
        setStockShowDialog(true);
        console.log("errr ", error);
        //window.location.href = "#/error";
      });
  };

  const fetchLinkRateCards = async (query) => {
    const requestId = ++linkRateCardSearchRequestRef.current;
    const encodedHash = utilities.encode(storeActiveShopHash.id);
    const url = storeApiUrl.BACKEND_BASE_URL + GETQUICKITEMS + "?s=" + encodedHash
      + "&q=" + encodeURIComponent(query) + "&m=1&stockVisible=-1";
    setLinkRateCardLoading(true);
    try {
      const response = await axios.get(url, {});
      if (linkRateCardSearchRequestRef.current !== requestId) return;
      const options = response.data.status === SUCCESS
        ? (response.data.jcJson.value_2 || [])
        : [];
      setLinkRateCardOptions(options);
    } catch (error) {
      if (linkRateCardSearchRequestRef.current === requestId) setLinkRateCardOptions([]);
      console.log("fetchLinkRateCards error ", error);
    } finally {
      if (linkRateCardSearchRequestRef.current === requestId) setLinkRateCardLoading(false);
    }
  };

  const handleLinkRateCardSearch = (event, value, reason) => {
    if (reason === "reset") return;
    const query = String(value ?? event?.target?.value ?? "").trim();
    if (linkRateCardSearchTimerRef.current) clearTimeout(linkRateCardSearchTimerRef.current);
    linkRateCardSearchRequestRef.current += 1;
    setLinkRateCardLoading(false);
    if (query.length < 3) {
      setLinkRateCardOptions(itemData?.id ? [itemData] : []);
      return;
    }
    linkRateCardSearchTimerRef.current = setTimeout(() => fetchLinkRateCards(query), 350);
  };

  const handleSetLinkStock = async () => {
    if (isEmpty(linkSingleData.linkedToId)) {
      setSnpComponent({ ...snpComponent, snackBarMsg: "Select Rate Card For Link", snackBarOpen: true });
      return;
    }
    if (isEmpty(linkSingleData.selectedUnit)) {
      setSnpComponent({ ...snpComponent, snackBarMsg: "Select Reduction Unit", snackBarOpen: true });
      return;
    }
    if (Number(linkSingleData.reductionQuantity) <= 0) {
      setSnpComponent({ ...snpComponent, snackBarMsg: "Enter Reduction Quantity > 0", snackBarOpen: true });
      return;
    }
    let cartUrl = storeApiUrl.BACKEND_BASE_URL + SETLINKOSTOCKENTRY;
    let data = {
      jcJson: {
        apiToken: getAuthSession().apiToken,
        shopHash: storeActiveShopHash.id,
        ...linkSingleData,
      }
    };
    //  console.log("getSupplierDetails  => ",data);
    setLoader(true);
    try {
      const response = await snpAxios.post(cartUrl, data);
      printDebugLog("response  => ", response.data);
      setLoader(false);
      if (response.data.status === SUCCESS) {
        handleLinkStockDialogClose();
        setSnpComponent({
          ...snpComponent,
          isLoader: false,
          negativeReq: false,
          positiveReq: true,
          positiveAction: "Ok",
          showDialog: true,
          outSideClickDismiss: true,
          cancelExtra: true,
          requestType: 99,
          subTitle: "Rate Card link updated successfully.",
          handleSnpSubmit: () => {
            setSnpComponent(INITIAL_SNP_COMPONENT);
            setDataLoaded(false);
            getRestoDetails();
          },
        });
      }
    } catch (error) {
      setLoader(false);
      console.log("errr ", error);
    }
  };


  const handleGetLinkStock = async (mStockId) => {
    let cartUrl = storeApiUrl.BACKEND_BASE_URL + GETLINKOSTOCKENTRY;
    let data = {
      jcJson: {
        apiToken: getAuthSession().apiToken,
        shopHash: storeActiveShopHash.id,
        stockId: mStockId,
      }
    };
    //  console.log("getSupplierDetails  => ",data);
    setLoader(true);
    snpAxios.post(
      cartUrl,
      data
    )
      .then((response) => {
        printDebugLog("response  => ", response.data);
        setLoader(false);
        if (response.data.status === SUCCESS) {
          const linkData = { ...INITIAL_LINK_STOCK, ...response.data.jcJson };
          setLinkSingleData(linkData);
          if (!isEmpty(linkData.linkedToId)) {
            const selectedRateCard = {
              id: linkData.linkedToId,
              name: linkData.linkedToName,
              details: linkData.linkedToName,
              conversionType: linkData.linkedToConversionType,
              conversionTypeDetails: linkData.linkedToConversionTypeDetails,
            };
            setItemData(selectedRateCard);
            setLinkRateCardOptions([selectedRateCard]);
          } else {
            setItemData(INITIAL_ITEM_DATA);
            setLinkRateCardOptions([]);
          }
          setLinkShowDialog(true);
        }
      }).catch((error) => {
        setLoader(false);
        console.log("errr ", error);
        //window.location.href = "#/error";
      });
  };

  const setStockEntryToServer = async () => {
    if (isEmpty(stockSingleData.cnvId)) {
      setSnpComponent({
        ...snpComponent, snackBarMsg: "Select Custom Unit", snackBarOpen: true,
      })
      return;
    }
    else if (stockSingleData.type === 2 && isEmpty(stockSingleData.purchasePrice)) {
      setSnpComponent({
        ...snpComponent, snackBarMsg: "Enter Purchase Price > 0.0", snackBarOpen: true,
      })
      return;
    } else if (stockSingleData.type === 2 && stockSingleData.purchasePrice <= 0.0) {
      setSnpComponent({
        ...snpComponent, snackBarMsg: "Enter Purchase Price > 0.0", snackBarOpen: true,
      })
      return;
    } else if (stockSingleData.type === 2 && (stockSingleData.unitRestrictions
      ? Number(stockSingleData.quantity) <= 0
      : Number(stockSingleData.smallQuantity) <= 0)) {
      setSnpComponent({
        ...snpComponent, snackBarMsg: "Enter Quantity > 0", snackBarOpen: true,
      })
      return;
    }
    let cartUrl = storeApiUrl.BACKEND_BASE_URL + SETRESTOSTOCKENTRY;
    let data = {
      jcJson: {
        apiToken: getAuthSession().apiToken,
        shopHash: storeActiveShopHash.id,
        ...stockSingleData,
        mfgDate: formatDateInSnp(stockSingleData.mfgDate, ""),
        expiryDate: formatDateInSnp(stockSingleData.expiryDate, ""),
        stockId: restoSingleData.id,
      }
    };
    //  console.log("getSupplierDetails  => ",data);
    setLoader(true);
    try {
      const response = await snpAxios.post(cartUrl, data);
      printDebugLog("response  => ", response.data);
      setLoader(false);
      if (response.data.status === SUCCESS) {
        handleStockDialogClose();
        setSnpComponent({
          ...snpComponent,
          isLoader: false,
          negativeReq: false,
          positiveReq: true,
          positiveAction: "Ok",
          showDialog: true,
          outSideClickDismiss: true,
          cancelExtra: true,
          requestType: 99,
          subTitle: "Record added successfull.",
          handleSnpSubmit: () => {
            setSnpComponent(INITIAL_SNP_COMPONENT);
            setDataLoaded(false);
            getRestoDetails();
          },
        });
      }
    } catch (error) {
      setLoader(false);
      console.log("errr ", error);
      // Keep the dialog and entered values available for correction.
    }
  };

  const fetchQuickItems = async (regextStr, mode, visibilityFilter = stockVisibilityFilter) => {
    const requestId = ++dishSearchRequestRef.current;
    let encodedHash = utilities.encode(storeActiveShopHash.id);
    const stockVisible = visibilityFilter === "all" ? -1 : visibilityFilter === "visible" ? 1 : 0;
    let fetchBillUrl = storeApiUrl.BACKEND_BASE_URL + GETQUICKITEMS + "?s=" + encodedHash
      + "&q=" + encodeURIComponent(regextStr) + "&m=" + mode + "&stockVisible=" + stockVisible
      + "&includeConversionDetails=false";
    let data = {};
    setDishSearchLoading(true);
    try {
      const response = await axios.get(fetchBillUrl, data);
      if (dishSearchRequestRef.current !== requestId) return;
      setCardPage(0);
      setPaginationModel((current) => ({ ...current, page: 0 }));
      if (response.data.status === SUCCESS) {
        setRestoData(response.data.jcJson.value_2 || []);
      } else {
        setRestoData([]);
      }
    } catch (error) {
      if (dishSearchRequestRef.current === requestId) setRestoData([]);
      console.log("errr ", error);
    } finally {
      if (dishSearchRequestRef.current === requestId) setDishSearchLoading(false);
    }
  };


  const renderDialogContent = () => {
    return (
      <React.Fragment>
        <div>
          <Grid container spacing={1} justifyContent="center" alignItems="center" >
            {
              restoSingleData.productImage.length > 0 && restoSingleData.productImage.map((item, index) => (
                <Card orientation="horizontal" size="md" key={"Image_" + index} variant="outlined">
                  <img
                    style={{ height: "80px", width: "80px", borderRadius: "40%" }}
                    srcSet={`${storeApiUrl.BACKEND_BASE_URL + "files/" + item}`}
                    src={`${storeApiUrl.BACKEND_BASE_URL + "files/" + item}`}
                    alt={"Image_" + index}
                  />
                  {
                    restoSingleData.productImage.length > 1 && <DeleteIcon
                      onClick={() => handleDeleteImage(index)} />
                  }

                </Card>

              ))
            }

            <Grid item md={6} sm={12} xs={12} lg={6} >
              <div style={{ display: "flex", alignItems: "center" }}>
                <input
                  accept="image/*"
                  id="imgPath"
                  name="imgPath"
                  label=""
                  type="file"
                  placeholder="Restaurant Image(Image should be less than 5Mb.)"
                  onChange={handleInputChange}
                  style={{ border: "1px solid lightgray", marginRight: "2px", padding: "3px 1px" }}
                />
                {
                  selectedImage &&
                  <img
                    alt=""
                    style={{ height: "80px", width: "80px", borderRadius: "40%" }}
                    // src={storeApiUrl.BACKEND_BASE_URL + "files/" + imgv}
                    src={selectedImage}
                  />
                }
              </div>
            </Grid>



            {imageSelectedError &&
              <p className="error" style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>Please select the Image (image format) having size below 5Mb before uploading.</p>
            }
            <Grid item md={12} sm={12} xs={12} lg={12} >

              <FormLabel component="legend">Select Food Type :</FormLabel>
              <RadioGroup row aria-label="foodType" name="foodType" value={restoSingleData.foodType.toString()} onChange={handleInputChange} >
                <FormControlLabel value={FoodType.VEG.toString()} control={<Radio />} label="Veg" />
                <FormControlLabel value={FoodType.NON_VEG.toString()} control={<Radio />} label="Non Veg" />
                <FormControlLabel value={FoodType.EGG.toString()} control={<Radio />} label="Egg" />
                <FormControlLabel value={FoodType.DRINK.toString()} control={<Radio />} label="Drink" />
                <FormControlLabel value={FoodType.ICE_CREAM.toString()} control={<Radio />} label="Ice Cream" />
                <FormControlLabel value={FoodType.SWEEETS.toString()} control={<Radio />} label="Sweets" />
                <FormControlLabel value={FoodType.NONE.toString()} control={<Radio />} label="Other" />
              </RadioGroup>
            </Grid>
            {
              dialogLoader && <Grid item xs={12}>
                <center>
                  <Loader /></center>
              </Grid>
            }

            <Grid item md={6} sm={12} xs={12} lg={6} >
              <Autocomplete
                id="catgselect"
                variant="filled"
                size="small"
                disabled={isEditProduct}
                options={categoryData}
                onChange={handleSelectChange}
                isOptionEqualToValue={(option, value) => option.catgId === value.catgId}
                getOptionLabel={(option) => option.catgName}
                defaultValue={selectedCategory}
                renderOption={(props, option) => (
                  <Box
                    component="li"
                    {...props}
                  >
                    {option.catgName}
                  </Box>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Choose a category"
                    inputProps={{
                      ...params.inputProps,
                    }}
                    style={{ width: "100%" }}
                  />
                )}
              />
            </Grid>
            <Grid item md={6} sm={12} xs={12} lg={6}>
              <TextField
                required
                id="prdName"
                variant="filled"
                size="small"
                label="Enter Dish Name"
                name="prdName"
                defaultValue={restoSingleData.prdName}
                onChange={handleInputChange}
                style={{ width: "100%" }}
              />
            </Grid>
            <Grid item md={6} sm={12} xs={12} lg={6}>
              <TextField
                required
                id="displayName"
                variant="filled"
                size="small"
                label="Kot Display Name"
                name="displayName"
                defaultValue={restoSingleData.displayName}
                onChange={handleInputChange}
                style={{ width: "100%" }}
              />
            </Grid>
            <Grid item md={12} sm={12} xs={12} lg={12}>
              <TextField
                required
                id="ingredients"
                variant="filled"
                size="small"
                label="Enter Ingredients(Comma Separated)"
                name="ingredients"
                defaultValue={restoSingleData.ingredients}
                onChange={handleInputChange}
                multiline={true}
                rows={3}
                style={{ width: "100%" }}
              />
            </Grid>
            <Grid item md={12} sm={12} xs={12} lg={12}>
              <FormLabel component="legend">Select Spice Level :</FormLabel>
              <RadioGroup row aria-label="spicy" name="spicy" value={restoSingleData.spicy.toString()} onChange={handleInputChange} >
                <FormControlLabel value={Spicy.LESS_SPICY.toString()} control={<Radio />} style={{ marginLeft: "0", marginRight: "0" }} label={<> Mild Spice <img style={{ height: "15px", width: "15px", borderRadius: "0%" }} src={spiceLevel1Logo} alt="Medium Spice" /> </>} />
                <FormControlLabel value={Spicy.MEDIUM_SPICY.toString()} control={<Radio />} style={{ marginLeft: "0", marginRight: "0" }} label={<>Medium Spice <img style={{ height: "15px", width: "15px", borderRadius: "0%" }} src={spiceLevel1Logo} alt="Medium Spice" /> <img style={{ height: "15px", width: "15px", borderRadius: "0%" }} src={spiceLevel1Logo} alt="Medium Spice" /></>} />
                <FormControlLabel value={Spicy.EXTRA_SPICY.toString()} control={<Radio />} style={{ marginLeft: "0", marginRight: "0" }} label={<>Hot Spice <img style={{ height: "15px", width: "15px", borderRadius: "0%" }} src={spiceLevel3Logo} alt="Hot Spice" /> </>} />
                <FormControlLabel value={Spicy.NONE.toString()} control={<Radio />} style={{ marginLeft: "0", marginRight: "0" }} label="None" />
              </RadioGroup>
            </Grid>
            <Grid item xs={12}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12, flexWrap: 'wrap' }}>
                <p style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word', margin: 0 }}>**Add Different Prices for your Dish(Eg: Half,Full,Regular)**</p>
                {!showRateCardEditor && <Button variant="filled" color="primary" onClick={() => {
                  setSelectedRateCard(INITIAL_RATE_CARD);
                  setShowRateCardEditor(true);
                }}>+ Add Rate Card</Button>}
              </div>
            </Grid>
            {showRateCardEditor && <Grid item xs={12}>
              <Grid container spacing={1}
                style={{ border: "1px solid black", padding: "30px 10px" }}>
                {stockManagementEnabled && <Grid item md={12} sm={12} xs={12} lg={12}>
                  <Autocomplete
                    options={conversionTypeData}
                    value={selectedRateCardConversion}
                    disableClearable={Boolean(selectedRateCard.hasStockEntries)}
                    disabled={Boolean(selectedRateCard.hasStockEntries)}
                    onChange={(event, option) => {
                      if (selectedRateCard.hasStockEntries) return;
                      setSelectedRateCard((current) => ({
                        ...current,
                        conversionType: option ? { id: option.id } : null,
                        holdStock: Boolean(option),
                      }));
                    }}
                    getOptionLabel={(option) => option.unitRestrictions
                      ? option.unitName
                      : `${option.unitName}/${option.smallUnitCount} ${option.smallUnitName} (loose)`}
                    renderInput={(params) => <TextField {...params} label="Conversion Type" variant="filled" size="small" />}
                  />
                </Grid>}
                <Grid item md={12} sm={12} xs={12} lg={12}>
                  <TextField
                    id="serialNo"
                    label="Enter Serial Number"
                    variant="filled"
                    size="small"
                    name="serialNo"
                    value={selectedRateCard.serialNo}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                  />
                </Grid>
                <Grid item md={12} sm={12} xs={12} lg={12}>
                  <TextField
                    id="name"
                    label={selectedRateCardConversion ? "Food Quantity Name (optional)" : "Food Quantity Name"}
                    variant="filled"
                    size="small"
                    name="name"
                    value={selectedRateCard.name}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                  />
                </Grid>
                <Grid item md={6} sm={6} xs={12} lg={6}>
                  <FormControl component="fieldset">
                    <FormLabel component="legend">Tax Method(Selling Price) : {Number(configuredGst.cgst) + Number(configuredGst.sgst)}%</FormLabel>
                    <RadioGroup row name="gstInclusive" value={selectedRateCard.gstInclusive} onChange={handleRateCardTaxMethodChange}>
                      <FormControlLabel value={true} control={<Radio />} label="Inc. GST" />
                      <FormControlLabel value={false} control={<Radio />} label="Exl. GST" />
                    </RadioGroup>
                  </FormControl>
                </Grid>
                <Grid item md={6} sm={6} xs={12} lg={6}>
                  <TextField
                    id="cAmt"
                    variant="filled"
                    size="small"
                    label={`Cost Price - ${selectedRateCardConversion?.unitName} (Without GST)`}
                    name="cAmt"
                    value={selectedRateCard.cAmt}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                  />
                  {selectedRateCardConversion && !selectedRateCardConversion.unitRestrictions &&
                    <Box sx={{ display: "flex", gap: 0.5, mt: 0.75, flexWrap: "wrap" }}>
                      <Button type="button" size="small" variant="outlined"
                        onClick={() => calculateRateCardPrice("cAmt", "smallUnitCAmt", "small")}>
                        {selectedRateCardConversion.unitName} → {selectedRateCardConversion.smallUnitName}
                      </Button>
                      <Button type="button" size="small" variant="outlined"
                        onClick={() => calculateRateCardPrice("smallUnitCAmt", "cAmt", "main")}>
                        {selectedRateCardConversion.smallUnitName} → {selectedRateCardConversion.unitName}
                      </Button>
                    </Box>}
                </Grid>
                {selectedRateCardConversion && !selectedRateCardConversion.unitRestrictions &&
                  <Grid item md={6} sm={6} xs={12} lg={6}>
                    <TextField
                      id="smallUnitCAmt"
                      variant="filled"
                      size="small"
                      label={`Cost Price - ${selectedRateCardConversion.smallUnitName} (Without GST)`}
                      name="smallUnitCAmt"
                      value={selectedRateCard.smallUnitCAmt}
                      onChange={handleInputChange}
                      style={{ width: "100%" }}
                    />
                  </Grid>}
                <Grid item md={6} sm={6} xs={12} lg={6}>
                  <TextField
                    id="sAmt"
                    variant="filled"
                    size="small"
                    label={`Selling Price - ${selectedRateCardConversion?.unitName} ${selectedRateCard.gstInclusive ? "(Including GST)" : "(Excluding GST)"}`}
                    name="sAmt"
                    value={selectedRateCard.sAmt}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                  />
                  {selectedRateCardConversion && !selectedRateCardConversion.unitRestrictions &&
                    <Box sx={{ display: "flex", gap: 0.5, mt: 0.75, flexWrap: "wrap" }}>
                      <Button type="button" size="small" variant="outlined"
                        onClick={() => calculateRateCardPrice("sAmt", "smallUnitSAmt", "small")}>
                        {selectedRateCardConversion.unitName} → {selectedRateCardConversion.smallUnitName}
                      </Button>
                      <Button type="button" size="small" variant="outlined"
                        onClick={() => calculateRateCardPrice("smallUnitSAmt", "sAmt", "main")}>
                        {selectedRateCardConversion.smallUnitName} → {selectedRateCardConversion.unitName}
                      </Button>
                    </Box>}
                  {(() => {
                    const gst = getRateCardGstBreakdown();
                    return <small style={{ display: "block", marginTop: 6 }}>
                      Base: {gst.basePrice} | CGST {configuredGst.cgst}%: {gst.cgstAmount} | SGST {configuredGst.sgst}%: {gst.sgstAmount} | Final: {gst.finalPrice}
                    </small>;
                  })()}
                </Grid>
                {selectedRateCardConversion && !selectedRateCardConversion.unitRestrictions &&
                  <Grid item md={6} sm={6} xs={12} lg={6}>
                    <TextField
                      id="smallUnitSAmt"
                      variant="filled"
                      size="small"
                      label={`Selling Price - ${selectedRateCardConversion.smallUnitName || "Small Unit"} ${selectedRateCard.gstInclusive ? "(Including GST)" : "(Excluding GST)"}`}
                      name="smallUnitSAmt"
                      value={selectedRateCard.smallUnitSAmt}
                      onChange={handleInputChange}
                      style={{ width: "100%" }}
                    />
                    {(() => {
                      const gst = getRateCardGstBreakdown(selectedRateCard.smallUnitSAmt);
                      return <small style={{ display: "block", marginTop: 6 }}>
                        Base: {gst.basePrice} | CGST {configuredGst.cgst}%: {gst.cgstAmount} | SGST {configuredGst.sgst}%: {gst.sgstAmount} | Final: {gst.finalPrice}
                      </small>;
                    })()}
                  </Grid>}
                <Grid item md={12} sm={12} xs={12} lg={12} className="rate_card__button--container">
                  {selectedRateCard.index === -1 &&
                    <Button variant="filled" color="primary" onClick={handleSubmitRate} className="rate_card--button" >
                      Add Rate Card
                    </Button>
                  }
                  {selectedRateCard.index >= 0 && <Button variant="filled" color="primary" className="rate_card--button" onClick={handleEditRate}>
                    Update rate card
                  </Button>}
                  {
                    selectedRateCard.index >= 0 && <Button variant="filled" color="bRed"
                      disabled={Boolean(selectedRateCard.hasStockEntries)} onClick={handleDeleteRateCard}>
                      Delete
                    </Button>
                  }
                  <Button variant="filled" onClick={() => {
                    setSelectedRateCard(INITIAL_RATE_CARD);
                    setShowRateCardEditor(false);
                  }}>
                    Cancel
                  </Button>
                </Grid>
              </Grid>
            </Grid>}

            <Grid item xs={12}>
                <TableContainer component={Paper}>
                  <Table aria-label="simple table" className="rate_card">
                    <TableHead>
                      <TableRow>
                        <TableCell align="center">Serial No</TableCell>
                        <TableCell align="center">Food Quantity</TableCell>
                        <TableCell align="center">Main Unit Cost Price</TableCell>
                        <TableCell align="center">Small Unit Cost Price</TableCell>
                        <TableCell align="center">Main Unit Selling Price</TableCell>
                        <TableCell align="center">Small Unit Selling Price</TableCell>
                        <TableCell align="center">Edit</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {Object.values(rateCard).map((val, index) => {
                        return (
                          <TableRow
                            key={index}
                            className="rate_card--row"
                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                            <TableCell align="center">{val.serialNo}</TableCell>
                            <TableCell align="center">{val.name ?? "-"}</TableCell>
                            <TableCell align="center">{val.cAmt}</TableCell>
                            <TableCell align="center">{val.conversionType && !val.conversionType.unitRestrictions ? val.smallUnitCAmt : "-"}</TableCell>
                            <TableCell align="center">{val.sAmt}</TableCell>
                            <TableCell align="center">{val.conversionType && !val.conversionType.unitRestrictions ? val.smallUnitSAmt : "-"}</TableCell>
                            <TableCell align="center"><EditIcon button onClick={() => handleSelectListChange(val, index)} /></TableCell>
                          </TableRow>
                        )
                      })}
                      {rateCard.length === 0 && <TableRow>
                        <TableCell align="center" colSpan={7}>No rate cards added.</TableCell>
                      </TableRow>}
                    </TableBody>
                  </Table>
                </TableContainer></Grid>
            {
              itemWiseOffer && <Grid item md={12} sm={12} xs={12} lg={12}>
                <FormLabel component="legend">Any Offer :</FormLabel>
                <RadioGroup row aria-label="offertype" name="offertype" value={restoSingleData.offertype.toString()} onChange={handleInputChange}>
                  <FormControlLabel value={OfferType.Flat.toString()} control={<Radio />} label="Discount In Flat" />
                  <FormControlLabel value={OfferType.Percentage.toString()} control={<Radio />} label="Discount In Percentage" />
                  <FormControlLabel value={OfferType.No_Offer.toString()} control={<Radio />} label="No Offer" />
                </RadioGroup>
              </Grid>
            }

            {
              (itemWiseOffer && restoSingleData.offertype > 1) &&
              <Grid item md={6} sm={6} xs={12} lg={6}>
                <TextField
                  required
                  id="offerAmt"
                  name="offerAmt"
                  variant="filled"
                  size="small"
                  label="Enter Offer Value"
                  value={restoSingleData.offerAmt.toString()}
                  onChange={handleInputChange}
                  style={{ width: "100%" }}
                /> </Grid>
            }

            <Grid item md={6} sm={6} xs={12} lg={6}>
              <TextField style={{ width: "100%" }}
                disabled
                id="sgst"
                name="sgst"
                variant="filled"
                size="small"
                label="SGST(In %)"
                value={restoSingleData.sgst}
                onChange={handleInputChange}
              />
            </Grid>
            <Grid item md={6} sm={6} xs={12} lg={6}>
              <TextField style={{ width: "100%" }}
                disabled
                id="cgst"
                name="cgst"
                variant="filled"
                size="small"
                label="CGST(In %)"
                value={restoSingleData.cgst}
                onChange={handleInputChange}
              />
            </Grid>
            <Grid item xs={12} md={6} sm={6} lg={6}>
              <FormControl component="fieldset">
                <FormLabel component="legend">
                  Enter Item Status
                </FormLabel>
                <RadioGroup
                  row
                  aria-label="itemStatus"
                  name="itemStatus"
                  value={Number(restoSingleData.itemStatus)}
                  onChange={handleInputChange}
                >
                  <FormControlLabel
                    value={Number(ItemStatus.ACTIVE)}
                    control={<Radio />}
                    label="Active"
                  />
                  <FormControlLabel
                    value={Number(ItemStatus.INACTIVE)}
                    control={<Radio />}
                    label="InActive"
                  />
                </RadioGroup>
              </FormControl>
            </Grid>
            {
              ecartApp && <Grid item xs={12} md={6} sm={6} lg={6}>
                <Autocomplete
                  multiple
                  disabled={(restoSingleData.itemStatus === ItemStatus.ACTIVE) ? false : true}
                  value={suggestedFoodItem}
                  options={foodItemData}
                  limitTags={2}
                  sx={{ width: 300 }}
                  onBlur={(e) => setFoodItemData([])}
                  onInputChange={handleItemSearchChange}
                  inputValue={inputValue}
                  isOptionEqualToValue={(option, value) => option.foodItemId === value.foodItemId}
                  getOptionLabel={(option) => option.foodItemName}
                  onChange={(event, newValue, reason, detail) => {
                    printDebugLog("Autocomplete", newValue, reason);
                    setInputValue('');
                    if (suggestionAvail) {
                      if (reason === 'removeOption') {
                        const updatedItems = [...suggestedFoodItemDeleted, detail.option.foodItemId];
                        setSuggestedFoodItemDeleted(updatedItems);
                      } else if (reason === 'selectOption') {
                        if (suggestedFoodItemDeleted.length > 0) {
                          let idToDelete = detail.option.foodItemId;
                          const indexToDelete = suggestedFoodItemDeleted.findIndex(item => item === idToDelete);
                          // If item is found, create a new array without it
                          if (indexToDelete !== -1) {
                            const updatedItems = [...suggestedFoodItemDeleted.slice(0, indexToDelete), ...suggestedFoodItemDeleted.slice(indexToDelete + 1)];
                            setSuggestedFoodItemDeleted(updatedItems);
                          }
                        }
                      } else if (reason === 'clear') {
                        suggestedFoodItem.forEach(element => {
                          const updatedItems = [...suggestedFoodItemDeleted, element.foodItemId];
                          setSuggestedFoodItemDeleted(updatedItems);
                        });
                      }
                    }
                    setSuggestedFoodItem(newValue);
                  }}
                  renderOption={(props, option) => (
                    <li {...props} key={option.foodItemId}>
                      {option.foodItemName}
                    </li>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Add Item Suggestion"
                      placeholder="Search"
                      onChange={handleFoodItemsSearch}
                    />
                  )}
                />
              </Grid>
            }
            {
              (ecartApp || isFeatureAllowed(THEMEMGMT)) && <Grid item md={12} xs={12} sm={12} lg={12} style={{ display: "flex", justifyContent: "center", color: "#01333e" }}>
                <center>
                  <FormControlLabel name="cartVisible"
                    checked={restoSingleData.cartVisible} disabled={(restoSingleData.itemStatus === ItemStatus.ACTIVE) ? false : true} control={<Checkbox />} onChange={() => {
                      let pVal = !restoSingleData.cartVisible;
                      setRestoSingleData({
                        ...restoSingleData,
                        cartVisible: pVal,
                      })
                    }} label="Item visible to end customer" />
                </center>
              </Grid>
            }
            {
              isFeatureAllowed(RECPMGMT) &&
              <Grid item md={12} xs={12} sm={12} lg={12} style={{ display: "flex", justifyContent: "center", color: "#01333e" }}>
                <center>
                  <FormControlLabel name="stockVisible"
                    checked={restoSingleData.stockVisible} disabled={(restoSingleData.itemStatus === ItemStatus.ACTIVE) ? false : true} control={<Checkbox />} onChange={() => {
                      let pVal = !restoSingleData.stockVisible;
                      setRestoSingleData({
                        ...restoSingleData,
                        stockVisible: pVal,
                      })
                    }} label="Item visible to Billing" />
                </center>
              </Grid>
            }

            {ecartApp &&
              <Grid item md={12} sm={12} xs={12} lg={12} style={{ display: "flex", justifyContent: "center", color: "#01333e" }}>
                <FormControlLabel control={<Checkbox
                  variant="filled"
                  size="small"
                  checked={restoSingleData.outOfStock}
                  onChange={handleInputChange} id="outOfStock" />}
                  name="outOfStock"
                  label={<> <strong>Out Of Stock </strong> </>} />
              </Grid>
            }
            {
              itemMultiAcc &&
              <p style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>**Note:This balance type used to separate this item into different account.Remember any balance type selection will not work in Home Delivery</p>}
            {
              itemMultiAcc && <Grid item md={6} xs={12} lg={6} sm={6}>
                <Autocomplete
                  id="bal-select"
                  options={listAcc}
                  autoHighlight
                  variant="filled"
                  size="small"
                  onChange={(e, val) => {
                    if (val != null) {
                      if (val === 'Other') {
                        setRestoSingleData({
                          ...restoSingleData,
                          accountName: "",
                          accountTitle: val,
                        })
                      } else {
                        setRestoSingleData({
                          ...restoSingleData,
                          accountName: val,
                          accountTitle: val,
                        })
                      }

                    } else {
                      setRestoSingleData({
                        ...restoSingleData,
                        accountName: "",
                        accountTitle: "",
                      })
                    }
                  }
                  }
                  isOptionEqualToValue={(option, value) => option === value}
                  getOptionLabel={(option) => option}
                  value={restoSingleData.accountTitle}
                  defaultValue={restoSingleData.accountTitle}
                  renderOption={(props, option) => (
                    <Box
                      component="li"
                      {...props}
                    >
                      {option}
                    </Box>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Select Balance Type"
                      inputProps={{
                        ...params.inputProps,
                      }}
                    />
                  )}
                />
              </Grid>
            }

            {
              restoSingleData.accountTitle === "Other" &&
              <Grid item md={6} xs={12} lg={6} sm={6}>
                <TextField
                  id="accountName"
                  name="accountName"
                  variant="filled"
                  size="small"
                  label="Enter Other Balance Type Name"
                  value={restoSingleData.accountName}
                  onChange={(e) => setRestoSingleData({
                    ...restoSingleData,
                    accountName: e.target.value,
                  })}
                />
              </Grid>
            }
          </Grid>
        </div>
      </React.Fragment >
    );
  }

  const renderDialogAction = () => {
    return (
      <React.Fragment>
        <SnpButton variant="contained" color="primary" onClick={handleImageUpload}>
          {!isEditProduct ? "Add" : "Update"}
        </SnpButton>
        <DismissButton variant="contained" color="primary" onClick={handleDialogClose}>
          Dismiss
        </DismissButton>
      </React.Fragment>
    );
  }

  const handleDialogClose = () => {
    // console.log("handleDialogClose");
    setShowDialog(false);
    clearProductData();
    setEditProduct(false);
    setImageSelectedError(false);
    setShowTable(false);
    setSuggestedFoodItem([]);
    setSuggAvail(false);
    setSuggestedFoodItemDeleted([]);
    if (globalEditor) onGlobalEditorClose();

  };

  const handleStockDialogClose = () => {
    // console.log("handleStockDialogClose");
    setStockShowDialog(false);
    setEditProduct(false);
    clearProductData();
    setListStockData([]);
    setSupplierData(INITIAL_SUPPLIER);
    if (stockPricingFeature) {
      setStockData(INITIAL_STOCK_DETAILS);
      setConversionSingleData(INITIAL_CONVERSION_SINGLE_DATA);
      setChoiceUnit({
        ...choiceUnit, smallUnitChecked: false, unitChecked: true,
      })
    } else {
      setStockData({
        ...stockSingleData,
        id: "",
        stockId: "", //Product Id
        stockName: "",
        supplierId: "",
        supplierName: "",
        billNo: "",
        mfgDate: "",
        expiryDate: "",
        sgst: 0.0,
        cgst: 0.0,
        custGstDisabled: false,
        fullPrice: 0.0,
        price: 0.0,
        liveStockCountStr: "",
        quantity: 0,
        smallQuantity: 0,
        predictiveSmallQuantity: 0,
        taxMethod: false,
        productmrPrice: 0.0,
        offerDenom: OfferType.No_Offer,
        offerAmt: 0.0,
        productSellingPrice: 0.0,
        productWholeSalePrice: 0.0,
        sproductmrPrice: 0.0,
        purchasePrice: 0.0,
        sofferDenom: OfferType.No_Offer,
        sofferAmt: 0.0,
        sproductSellingPrice: 0.0,
        sproductWholeSalePrice: 0.0,
        buyerGstTaken: true,
        isExpired: false,
        createdAt: "",
      })
    }
  };


  const handleLinkStockDialogClose = () => {
    // console.log("handleStockDialogClose");
    if (linkRateCardSearchTimerRef.current) clearTimeout(linkRateCardSearchTimerRef.current);
    linkRateCardSearchRequestRef.current += 1;
    setLinkShowDialog(false);
    setLinkRateCardLoading(false);
    setLinkRateCardOptions([]);
    setItemData(INITIAL_ITEM_DATA)
    setLinkSingleData(INITIAL_LINK_STOCK);
  };

  const renderLinkStockDialogContent = () => {
    const reductionUnits = getLinkReductionUnits(linkSingleData.linkedToConversionType);
    const wholeUnitsOnly = Boolean(
      linkSingleData.linkedToConversionType?.decimalSmRestrictions);
    return (
      <>
        <Grid container spacing={2} justifyContent="center" alignItems="center">
          <Grid item xs={12} md={6} lg={6} sm={12}>
            <TextField
              required
              id="stockName"
              name="stockName"
              disabled
              variant="filled"
              size="small"
              label="Source Rate Card"
              value={linkSingleData.stockName}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} md={6} lg={6} sm={12}>
            <Autocomplete
              required
              id="item-select"
              options={linkRateCardOptions}
              autoHighlight
              openOnFocus
              variant="filled"
              size="small"
              loading={isLinkRateCardLoading}
              loadingText="Searching Rate Cards..."
              noOptionsText="Type at least 3 characters to search Rate Cards"
              value={itemData?.id ? itemData : null}
              onInputChange={handleLinkRateCardSearch}
              onChange={(event, val) => {
                if (val != null) {
                  const displayName = val.details || val.name;
                  const reductionUnits = getLinkReductionUnits(val.conversionType);
                  const selectedRateCard = { ...val, name: displayName };
                  setItemData(selectedRateCard);
                  setLinkSingleData({
                    ...linkSingleData,
                    linkedToId: val.id,
                    linkedToName: displayName,
                    linkedToConversionType: val.conversionType,
                    linkedToConversionTypeDetails: val.conversionTypeDetails || "",
                    selectedUnit: reductionUnits[0] || "",
                    smallQuantity: 0,
                    reductionQuantity: 0,
                  });
                } else {
                  setItemData(INITIAL_ITEM_DATA);
                  setLinkSingleData({
                    ...linkSingleData,
                    linkedToId: "",
                    linkedToName: "",
                    linkedToConversionType: null,
                    linkedToConversionTypeDetails: "",
                    selectedUnit: "",
                    smallQuantity: 0,
                    reductionQuantity: 0,
                  });
                }
              }}
              fullWidth
              getOptionLabel={(option) => option.details || option.name || ""}
              isOptionEqualToValue={(option, value) => option.id === value.id}
              filterOptions={(options) => options}
              getOptionDisabled={(option) => Boolean(
                getLinkRateCardDisabledReason(option, linkSingleData.stockId))}
              renderOption={(props, option) => {
                const disabledReason = getLinkRateCardDisabledReason(option, linkSingleData.stockId);
                return (
                  <li {...props} key={`${option.id}`}>
                    {option.details || option.name}
                    {disabledReason ? ` - ${disabledReason}` : ""}
                  </li>
                );
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Search Rate Card For Link"
                  inputProps={{
                    ...params.inputProps,
                  }}
                />
              )}
            />
          </Grid>
          <Grid item md={6} lg={6} sm={6} xs={12}>
            <FormControl fullWidth>
              <FormLabel component="label" htmlFor="link-reduction-unit">Reduction Unit</FormLabel>
              <select
                id="link-reduction-unit"
                aria-label="Reduction Unit"
                value={linkSingleData.selectedUnit}
                disabled={reductionUnits.length === 0}
                onChange={(event) => setLinkSingleData({
                  ...linkSingleData,
                  selectedUnit: event.target.value,
                })}
                style={{ minHeight: 40, width: "100%" }}
              >
                <option value="" disabled>Select Reduction Unit</option>
                {reductionUnits.map((unit) =>
                  <option key={unit} value={unit}>{unit}</option>)}
              </select>
            </FormControl>
          </Grid>
          <Grid item md={6} lg={6} sm={6} xs={12}>
            <TextField
              id="reductionQuantity"
              name="reductionQuantity"
              variant="filled"
              size="small"
              type="number"
              inputProps={{
                min: 0,
                step: wholeUnitsOnly ? 1 : "any",
                inputMode: wholeUnitsOnly ? "numeric" : "decimal",
              }}
              label={`Quantity to reduce per sold item${linkSingleData.selectedUnit ? ` (${linkSingleData.selectedUnit})` : ""}`}
              value={linkSingleData.reductionQuantity}
              onChange={(e) => {
                const value = e.target.value;
                if (!isValidRestoQuantityInput(value, wholeUnitsOnly)) return;
                setLinkSingleData({
                  ...linkSingleData,
                  reductionQuantity: value,
                  smallQuantity: value,
                });
              }}
              fullWidth
            />
          </Grid>
        </Grid>
      </>
    );
  };

  const renderLinkStockDialogAction = () => {
    return (
      <>
        <SnpButton variant="contained" color="primary" onClick={handleSetLinkStock}>
          Update
        </SnpButton>

        <DismissButton variant="contained" color="primary" onClick={handleLinkStockDialogClose}>
          Dismiss
        </DismissButton>
      </>
    );
  }

  const renderStockDialogContent = () => {
    return (
      <>
        <Grid container spacing={1} justifyContent="center" alignItems="center">
          {
            stockSingleData.isExpired && <Grid item xs={12}>
              <FormControlLabel disabled control={<Checkbox checked={stockSingleData.isExpired}
                id="isExpired" />} name="isExpired" label="Is Expired" />
            </Grid>
          }

          <Grid item xs={12} md={12} lg={12} sm={12} >
            <FormControl component="fieldset">
              <FormLabel component="legend">
                Select Stock Type
              </FormLabel>
              <RadioGroup
                row
                aria-label="type"
                name="type"
                disabled={stockSingleData.systemGenerated}
                value={stockSingleData.type}
                onChange={(e) => {
                  setStockData({
                    ...stockSingleData,
                    type: Number(e.target.value),
                  })
                }}
              >
                <FormControlLabel
                  value={1}
                  disabled={stockSingleData.systemGenerated}
                  control={<Radio />}
                  label="Reduce"
                />
                <FormControlLabel
                  value={2}
                  disabled={stockSingleData.systemGenerated}
                  control={<Radio />}
                  label="Add"
                />
              </RadioGroup>
            </FormControl>
          </Grid>


          <Grid item xs={12} md={6} lg={6} sm={6}>
            <TextField
              required
              id="stockName"
              name="stockName"
              disabled
              variant="filled"
              size="small"
              label="Item Name"
              value={`${restoSingleData.prdName} ${restoSingleData.foodQuantityName}`}
              fullWidth
            />
          </Grid>

          <Grid item xs={12} md={6} lg={6} sm={6}>
            <TextField
              required
              id="billNo"
              name="billNo"
              variant="filled"
              size="small"
              disabled={stockSingleData.systemGenerated}
              label="Enter Bill Number"
              value={stockSingleData.billNo}
              onChange={(e) => setStockData({
                ...stockSingleData, billNo: e.target.value,
              })}
              fullWidth
            />
          </Grid>
          {
            stockSingleData.type === 2/*Credit*/ && <Grid item xs={12} md={6} lg={6} sm={6}>
              <TextField
                id="mfgDate"
                name="mfgDate"
                variant="filled"
                size="small"
                disabled={stockSingleData.systemGenerated}
                label="Enter Manufacture Date"
                value={formatDateInReact(stockSingleData.mfgDate)}
                onChange={(e) => setStockData({
                  ...stockSingleData, mfgDate: e.target.value,
                })}
                fullWidth
                type="date"
                InputLabelProps={{
                  shrink: true,
                }} />
            </Grid>
          }
          {
            stockSingleData.type === 2/*Credit*/ &&
            <Grid item xs={12} md={6} lg={6} sm={6}>
              <TextField
                id="expiryDate"
                name="expiryDate"
                variant="filled"
                size="small"
                disabled={stockSingleData.systemGenerated}
                label="Enter Expiry Date"
                value={formatDateInReact(stockSingleData.expiryDate)}
                onChange={(e) => setStockData({
                  ...stockSingleData, expiryDate: e.target.value,
                })}
                fullWidth
                type="date"
                InputLabelProps={{
                  shrink: true,
                }} />
            </Grid>
          }

          {
            (stockSingleData.type === 2/*Credit*/ && isFeatureAllowed(SUPMGMT)) &&
            <Grid item xs={12} md={6} lg={6} sm={6}>
              <Autocomplete
                required
                id="supplier-select"
                options={listSupplierData}
                autoHighlight
                variant="filled"
                disabled={stockSingleData.systemGenerated}
                size="small"
                onChange={handleSupplierChange}
                fullWidth
                isOptionEqualToValue={(option, value) => option.supplierId === value.supplierId}
                getOptionLabel={(option) => option.supplierName}
                defaultValue={supplierData}
                renderOption={(props, option) => (
                  <Box
                    component="li"
                    {...props}
                  >
                    {option.supplierName}
                  </Box>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Select Supplier Information"
                    inputProps={{
                      ...params.inputProps,
                    }}
                  />
                )}
              />
            </Grid>
          }

          {/* <Grid item md={6} lg={6} sm={6} xs={12}>
            <Autocomplete
              id="cnv-select"
              size="small"
              options={conversionTypeData}
              disabled={true}
              onChange={handleConversionChange}
              fullWidth
              getOptionLabel={(option) => getCustomUnitDetails(option)}
              defaultValue={conversionSingleData}
              renderOption={(props, option) => (
                <Box
                  component="li"

                  {...props}
                >
                  {getCustomUnitDetails(option)}
                </Box>
              )}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Select Custom Unit Type"
                  inputProps={{
                    ...params.inputProps,
                  }}
                />
              )}
            />
          </Grid> */}
          {
            !isEmpty(conversionSingleData.cnvId) &&
            <Grid item md={6} lg={6} sm={6} xs={12}>
              <TextField
                id="quantity"
                name="quantity"
                variant="filled"
                size="small"
                disabled={stockSingleData.systemGenerated}
                label={"Enter Quantity(for " + conversionSingleData.unitName + ")"}
                value={stockSingleData.quantity}
                onChange={(e) => {
                  const value = e.target.value;
                  if (!isValidRestoQuantityInput(
                    value, conversionSingleData.decimalSmRestrictions)) return;
                  const predictiveSmallQuantity = conversionSingleData.unitRestrictions ? 0
                    : calculatePredictiveSmallQuantity(value, conversionSingleData.smallUnitCount);
                  setStockData({
                    ...stockSingleData,
                    quantity: value,
                    smallQuantity: predictiveSmallQuantity,
                    predictiveSmallQuantity,
                  });
                }}
                inputProps={{
                  inputMode: conversionSingleData.decimalSmRestrictions ? "numeric" : "decimal",
                  step: conversionSingleData.decimalSmRestrictions ? 1 : "any",
                  min: 0,
                }}
                fullWidth
              />
            </Grid>
          }
          {
            !isEmpty(conversionSingleData.cnvId) && !conversionSingleData.unitRestrictions
              && Number(conversionSingleData.smallUnitCount) > 0 &&
            <Grid item md={6} lg={6} sm={6} xs={12}>
              <TextField
                id="smallQuantity"
                name="smallQuantity"
                variant="filled"
                size="small"
                disabled={stockSingleData.systemGenerated}
                label={"Enter Quantity(for " + conversionSingleData.smallUnitName + ")"}
                value={stockSingleData.smallQuantity}
                onChange={(e) => {
                  const value = e.target.value;
                  if (!isValidRestoQuantityInput(value, conversionSingleData.decimalSmRestrictions)) return;
                  const quantity = calculateMainQuantityFromSmall(
                    value, conversionSingleData.smallUnitCount,
                    conversionSingleData.decimalSmRestrictions);
                  setStockData({
                    ...stockSingleData,
                    quantity,
                    smallQuantity: value === "" ? "" : Number(value),
                    predictiveSmallQuantity: value === "" ? "" : Number(value),
                  });
                }}
                inputProps={{
                  inputMode: conversionSingleData.decimalSmRestrictions ? "numeric" : "decimal",
                  step: conversionSingleData.decimalSmRestrictions ? 1 : "any",
                  min: 0,
                }}
                fullWidth
              />
            </Grid>
          }
          {stockSingleData.type === 2/*Credit*/ &&
            <Grid item md={6} lg={6} sm={6} xs={12}>
              <TextField
                required
                id="purchasePrice"
                name="purchasePrice"
                variant="filled"
                size="small"
                disabled={stockSingleData.systemGenerated}
                label="Enter Purchase Price"
                value={stockSingleData.purchasePrice}
                onChange={(e) => {
                  let val = e.target.value;
                  if (!isNumberEmpty(val)) {
                    setStockData({
                      ...stockSingleData, purchasePrice: Number(e.target.value),
                    })
                  } else {
                    setStockData({
                      ...stockSingleData, purchasePrice: "",
                    })
                  }
                }}
                fullWidth
              />
            </Grid>
          }
          <Grid item md={6} lg={6} sm={6} xs={12}>
            <TextField
              id="description"
              variant="filled"
              size="small"
              label="Enter Description"
              name="description"
              disabled={stockSingleData.systemGenerated}
              defaultValue={stockSingleData.description}
              onChange={(e) => setStockData({
                ...stockSingleData, description: e.target.value,
              })}
              multiline={true}
              rows={3}
              fullWidth
            />
          </Grid>
          {listStockData.length > 0 &&
            <Grid item md={12} sm={12} xs={12} lg={12}>
              <TableContainer component={Paper}>
                <Table aria-label="simple table" className="rate_card">
                  <TableHead>
                    <TableRow>
                      <TableCell align="center"></TableCell>
                      <TableCell align="center">Bill No</TableCell>
                      <TableCell align="center">Quantity</TableCell>
                      <TableCell align="center">Purchase Price</TableCell>
                      <TableCell align="center">At</TableCell>
                      <TableCell align="center">Edit</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {listStockData.map((val, index) => {
                      return (
                        <TableRow
                          className="rate_card--row"
                          key={index}
                          sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                          <TableCell align="center">{val.typeStr}</TableCell>
                          <TableCell align="center">{val.billNo}</TableCell>
                          <TableCell align="center">{getQuantityDetails(val)}</TableCell>
                          <TableCell align="center">{"₹" + val.purchasePrice}</TableCell>
                          <TableCell align="center">{val.createdAt}</TableCell>
                          <TableCell align="center"><EditIcon button onClick={() => handleSelectStock(val)} /></TableCell>
                        </TableRow>
                      )
                    })}
                  </TableBody>
                </Table>
              </TableContainer></Grid>
          }
          {
            listStockData.length > 0 && <Grid item md={6} lg={6} sm={6} xs={12}>
              <center><SnpButton variant="contained" mbgcolor="#009ac7"
                onClick={() => navigate("/dashboard/stockentry", { state: { prdId: restoSingleData.id } })}>
                See All Stock
              </SnpButton></center>
            </Grid>
          }

        </Grid >
      </>
    )
  };

  const renderStockDialogAction = () => {
    return (
      <>
        {
          isEditProduct && <SnpButton variant="contained" color="primary" onClick={(e) => {
            setEditProduct(false);
            setStockData({
              ...stockSingleData,
              id: "",
              stockId: "", //Product Id
              stockName: "",
              supplierId: "",
              supplierName: "",
              billNo: "",
              mfgDate: "",
              expiryDate: "",
              quantity: 0,
              sgst: 0.0,
              cgst: 0.0,
              custGstDisabled: false,
              fullPrice: 0.0,
              price: 0.0,
              liveStockCountStr: "",
              smallQuantity: 0,
              predictiveSmallQuantity: 0,
              taxMethod: false,
              productmrPrice: 0.0,
              offerDenom: OfferType.No_Offer,
              offerAmt: 0.0,
              productSellingPrice: 0.0,
              productWholeSalePrice: 0.0,
              sproductmrPrice: 0.0,
              purchasePrice: 0.0,
              sofferDenom: OfferType.No_Offer,
              sofferAmt: 0.0,
              sproductSellingPrice: 0.0,
              sproductWholeSalePrice: 0.0,
              buyerGstTaken: true,
              isExpired: false,
              type: 2,
              systemGenerated: false,
              description: "",
            })
          }}>
            Create New
          </SnpButton>
        }
        {
          !stockSingleData.systemGenerated && <SnpButton variant="contained" color="primary" onClick={setStockEntryToServer}>
            Update
          </SnpButton>
        }

        <DismissButton variant="contained" color="primary" onClick={handleStockDialogClose}>
          Dismiss
        </DismissButton>
      </>
    );
  }

  const clearDishSearch = () => {
    dishSearchRequestRef.current += 1;
    if (dishSearchTimerRef.current) clearTimeout(dishSearchTimerRef.current);
    setDishSearchValue('');
    setDishSearchLoading(false);
    setRestoData(baseRestoData);
    setCardPage(0);
    setPaginationModel((current) => ({ ...current, page: 0 }));
  };

  const handleDishSearchChange = (event) => {
    const value = event.target.value;
    const trimmedValue = value.trim();
    setDishSearchValue(value);
    if (dishSearchTimerRef.current) clearTimeout(dishSearchTimerRef.current);
    dishSearchRequestRef.current += 1;
    setDishSearchLoading(false);
    if (trimmedValue.length < 3) {
      setRestoData(baseRestoData);
      setCardPage(0);
      return;
    }
    setDishSearchLoading(true);
    dishSearchTimerRef.current = setTimeout(() => {
      fetchQuickItems(trimmedValue, 1, stockVisibilityFilter);
    }, 350);
  };

  const showCardActionDenied = (message) => {
    setSnpComponent((current) => ({
      ...current,
      isLoader: false,
      negativeReq: false,
      positiveReq: true,
      positiveAction: "Ok Got it",
      showDialog: true,
      outSideClickDismiss: true,
      cancelExtra: true,
      requestType: 99,
      subTitle: message,
      handleSnpSubmit: () => setSnpComponent(INITIAL_SNP_COMPONENT),
    }));
  };

  const handleCardEdit = (event, item) => {
    if (isRoleAllowed(STOCKMGMT, ROLE_UPDATE)) {
      handleCellClick(event, { row: item }, false);
    } else {
      showCardActionDenied(stockManagementEnabled
        ? "You Are not allowed to Add/Update Item Details.Contact the Owner"
        : "You Are not allowed to Add/Update Stock Details.Contact the Owner");
    }
  };

  const handleCardStock = (event, item) => {
    if (isRoleAllowed(STOCKMGMT, ROLE_UPDATE)) {
      handleCellClick(event, { row: item }, true);
    } else {
      showCardActionDenied("You Are not allowed to Add/Update Stock Details.Contact the Owner");
    }
  };

  const handleCardLink = (item) => {
    if (isRoleAllowed(STOCKMGMT, ROLE_UPDATE)) {
      handleGetLinkStock(item.id);
    } else {
      showCardActionDenied("You Are not allowed to Add/Update Stock Details.Contact the Owner");
    }
  };

  const cardPageSize = 12;
  const cardPageCount = Math.max(1, Math.ceil(restoData.length / cardPageSize));
  const visibleCardItems = restoData.slice(cardPage * cardPageSize, (cardPage + 1) * cardPageSize);

  const renderSnpContent = () => {
    return (
      <Grid container spacing={1}
        alignItems="center"
        justifyContent="center">
        <Grid item md={5} xs={12} sm={6}>
          <div className="resto-layout-search">
            <TextField
              id="resto-layout-search-input"
              label="Search Dish Name"
              value={dishSearchValue}
              onChange={handleDishSearchChange}
              fullWidth
              inputProps={{ autoComplete: "off" }}
            />
            {dishSearchValue && <button type="button" onClick={clearDishSearch}>Clear</button>}
            <small>{dishSearchValue.trim().length > 0 && dishSearchValue.trim().length < 3
              ? "Type at least 3 characters"
              : "Search results appear directly in the selected layout"}</small>
          </div>
          <div className="resto-visibility-filter" role="radiogroup" aria-label="Restaurant item visibility">
            <span className="resto-visibility-filter__label">Show items</span>
            <div className="resto-visibility-filter__options" aria-busy={listLoading}>
              {[
                { value: "visible", label: "Visible to Billing" },
                { value: "notBilled", label: "Not Billed Item" },
                { value: "all", label: "All" },
              ].map((option) => (
                <button
                  key={option.value}
                  type="button"
                  role="radio"
                  aria-checked={stockVisibilityFilter === option.value}
                  className={`resto-visibility-filter__option resto-visibility-filter__option--${option.value}${stockVisibilityFilter === option.value ? " is-selected" : ""}`}
                  disabled={listLoading}
                  onClick={() => handleStockVisibilityFilterChange(option.value)}
                >
                  {option.label}
                </button>
              ))}
            </div>
          </div>
        </Grid>
        <Grid item md={5} xs={12} sm={6} >
          <div className="resto-product-stock__primary-actions">
            {stockManagementEnabled && <EnterButton variant="contained" color="primary"
              onClick={() => {
                if (isRoleAllowed(STOCKMGMT, ROLE_UPDATE)) {
                  setBulkStockDialog(true);
                } else {
                  showCardActionDenied("You Are not allowed to Add/Update Stock Details.Contact the Owner");
                }
              }}>
              Bulk Add Stock
            </EnterButton>}
            <EnterButton variant="contained" color="primary" style={{ float: 'right' }} className="float-right"
              onClick={(event) => {
                if (isRoleAllowed([INVSTOCKMGMT, FOODITEMPRODUCTMGMT], ROLE_CREATE)) {
                  setShowDialog(true);
                } else {
                  setSnpComponent({
                    ...snpComponent,
                    isLoader: false,
                    negativeReq: false,
                    positiveReq: true,
                    positiveAction: "Ok Got it",
                    showDialog: true,
                    outSideClickDismiss: true,
                    cancelExtra: true,
                    requestType: 99,
                    subTitle: "You Are not allowed to Add/Update Stock Details.Contact the Owner",
                    handleSnpSubmit: () => setSnpComponent(INITIAL_SNP_COMPONENT),
                  });
                }
              }}>
              Add New Restaurant Data
            </EnterButton>
          </div>
        </Grid>
        < DialogBox
          showDialog={showDialog}
          title={isEditProduct ? "Update Restaurant Data" : "Add New Restaurant Data"}
          onClose={handleDialogClose}
          dialogContent={renderDialogContent()}
          dialogActions={renderDialogAction()}
        />
        < DialogBox
          showDialog={showStockDialog}
          title={isEditProduct ? "Update Stock Details" : "Add new Stock entry"}
          onClose={handleStockDialogClose}
          dialogContent={renderStockDialogContent()}
          dialogActions={renderStockDialogAction()}
        />
        < DialogBox
          showDialog={linkStockDialog}
          title="Link Stock"
          onClose={handleLinkStockDialogClose}
          dialogContent={renderLinkStockDialogContent()}
          dialogActions={renderLinkStockDialogAction()}
        />
        <GlobalRestoBulkStock
          open={bulkStockDialog}
          onClose={() => setBulkStockDialog(false)}
          onSaved={(count) => {
            setSnpComponent((current) => ({
              ...current,
              snackBarOpen: true,
              snackBarMsg: `${count} stock ${count === 1 ? "entry" : "entries"} added successfully.`,
            }));
            getRestoDetails();
          }}
          baseUrl={storeApiUrl.BACKEND_BASE_URL}
          shopHash={storeActiveShopHash.id}
          cartType={storeActiveShopHash.cartType}
        />
        <Grid item xs={12}>
          <div className="resto-list-view-toolbar">
            <span className="resto-list-view-toolbar__count">
              {restoData.length} item{restoData.length === 1 ? "" : "s"}{dishSearchValue.trim().length >= 3 ? ` matching “${dishSearchValue.trim()}”` : ""}
            </span>
            <div className="resto-list-view-toggle" role="group" aria-label="Restaurant item view">
              <button
                type="button"
                title="Table view"
                aria-label="Show table view"
                aria-pressed={listViewMode === "table"}
                className={`resto-list-view-toggle__button${listViewMode === "table" ? " is-selected" : ""}`}
                onClick={() => setListViewMode("table")}
              >
                <TableViewIcon />
              </button>
              <button
                type="button"
                title="Card view"
                aria-label="Show card view"
                aria-pressed={listViewMode === "card"}
                className={`resto-list-view-toggle__button${listViewMode === "card" ? " is-selected" : ""}`}
                onClick={() => setListViewMode("card")}
              >
                <ViewCozyOutlinedIcon />
              </button>
            </div>
          </div>
        </Grid>
        {listViewMode === "table" ?
          <Grid item xs={12}>
            <CustomDataGrid
              getRowId={row => row.id}
              rows={restoData}
              columns={stockManagementEnabled ? columnsWithStock : columns}
              loading={listLoading || !isDataLoaded}
              paginationMode="client"
              paginationModel={paginationModel}
              onPageDataChange={(e) => setPaginationModel({
                ...paginationModel, page: e,
              })}
              cbPageSizeChange={(mPageSize) => setPaginationModel({
                ...paginationModel, pageSize: mPageSize,
              })}
            />
          </Grid>
          :
          <Grid item xs={12}>
            <div className="resto-product-card-grid" aria-busy={listLoading}>
              {visibleCardItems.map((item) => {
                const productImage = item.productImage?.[0];
                return <article className="resto-product-card" key={item.id}>
                  <div className="resto-product-card__media">
                    {productImage ? <img
                      src={storeApiUrl.BACKEND_BASE_URL + "files/" + productImage}
                      alt={item.name || "Restaurant item"}
                      loading="lazy"
                    /> : <div className="resto-product-card__image-placeholder">{item.name?.charAt(0) || "R"}</div>}
                    <span className={`resto-product-card__status${item.itemStatusStr === "Active" ? " is-active" : ""}`}>
                      {item.itemStatusStr || "Unknown"}
                    </span>
                  </div>
                  <div className="resto-product-card__body">
                    <div className="resto-product-card__heading">
                      <div>
                        <span className="resto-product-card__category">{item.catgName || "Uncategorised"}</span>
                        <h3>{item.name || "Unnamed item"}</h3>
                      </div>
                      <span className="resto-product-card__food-type">{item.foodTypeStr || "None"}</span>
                    </div>
                    {stockManagementEnabled && <div className="resto-product-card__details">
                      <div><span>Food Quantity</span><strong>{item.foodQuantityName || "-"}</strong></div>
                      <div><span>Selling Price</span><strong>{item.sellingPrice ?? "-"}</strong></div>
                      <div><span>Stock Count</span><strong>{item.liveStockCount || "-"}</strong></div>
                      <div><span>Visible to Billing</span><strong>{item.stockVisibleStr || "-"}</strong></div>
                    </div>}
                    <div className="resto-product-card__actions">
                      <button type="button" title="Edit item" aria-label={`Edit ${item.name || "item"}`} onClick={(event) => handleCardEdit(event, item)}>
                        <EditIcon />
                      </button>
                      {stockManagementEnabled && <>
                        <button type="button" title="Add stock" aria-label={`Add stock for ${item.name || "item"}`} onClick={(event) => handleCardStock(event, item)}>
                          <InventoryIcon />
                        </button>
                        <button type="button" title="Link stock" aria-label={`Link stock for ${item.name || "item"}`} onClick={() => handleCardLink(item)}>
                          <AddLinkIcon />
                        </button>
                      </>}
                    </div>
                  </div>
                </article>
              })}
            </div>
            {restoData.length === 0 && !listLoading && <div className="resto-product-card-empty">No restaurant items found.</div>}
            {restoData.length > cardPageSize && <div className="resto-product-card-pagination">
              <button type="button" disabled={cardPage === 0} onClick={() => setCardPage((page) => Math.max(0, page - 1))}>Previous</button>
              <span>Page {cardPage + 1} of {cardPageCount}</span>
              <button type="button" disabled={cardPage + 1 >= cardPageCount} onClick={() => setCardPage((page) => Math.min(cardPageCount - 1, page + 1))}>Next</button>
            </div>}
          </Grid>}
        {videoModel.show && <YouTubeVideo videoId={videoModel.path} onDismiss={(e) => setVideoModel({ ...videoModel, show: false })} />}
        {videoModel.path && <SingleFab onClick={(e) => setVideoModel({ ...videoModel, show: true })} />}
      </Grid>
    )
  }


  if (globalEditor) {
    return (
      <SnpComponent
        showDialog={snpComponent.showDialog}
        title={snpComponent.title}
        isLoader={isLoader}
        subTitle={snpComponent.subTitle}
        negativeAction={snpComponent.negativeAction}
        positiveReq={snpComponent.positiveReq}
        positiveAction={snpComponent.positiveAction}
        negativeReq={snpComponent.negativeReq}
        handleDialogClose={() => setSnpComponent(INITIAL_SNP_COMPONENT)}
        iconReq={snpComponent.iconReq}
        onSnackClose={handleSnackClose}
        snackBarOpen={snpComponent.snackBarOpen}
        snackBarMsg={snpComponent.snackBarMsg}
        content={<>
        {isLoader ? <Loader /> : null}
        <DialogBox
          showDialog={showDialog}
          title="Update Restaurant Data"
          onClose={handleDialogClose}
          dialogContent={renderDialogContent()}
          dialogActions={renderDialogAction()}
          mwidth="lg"
          mFullWidth
        />
        </>}
      />
    );
  }

  return (
    <SnpComponent showDialog={snpComponent.showDialog}
      title={snpComponent.title}
      isLoader={isLoader || listLoading}
      subTitle={snpComponent.subTitle}
      negativeAction={snpComponent.negativeAction}
      positiveReq={snpComponent.positiveReq}
      positiveAction={snpComponent.positiveAction}
      negativeReq={snpComponent.negativeReq}
      handleDialogClose={(e) => setSnpComponent(INITIAL_SNP_COMPONENT)}
      iconReq={snpComponent.iconReq}
      content={renderSnpContent()}
      onSnackClose={handleSnackClose}
      cancelExtra={snpComponent.cancelExtra}
      onCancel={snpComponent.handleSnpCancel}
      snackBarOpen={snpComponent.snackBarOpen}
      snackBarMsg={snpComponent.snackBarMsg}
      outSideClickDismiss={snpComponent.outSideClickDismiss}
      handleSubmit={snpComponent.handleSnpSubmit}
      gui={snpComponent.gui}
    />
  );
}
